import {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useCallback,
  useMemo,
} from "react";
import "../css/PagesCommonStyle.css";
import {
  faCheckCircle,
  faMagnifyingGlass,
  faPrint,
  faShieldHalved,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExcel,
  faFilePdf,
  faTrashCan,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-regular-svg-icons";
import { useSelector, useDispatch } from "react-redux";
import {
  faTriangleExclamation,
  faStar,
  faCircleInfo,
  faXmark,
  faPlus,
  faMinus,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import {
  APIConstants,
  IntelliBillConstants,
  CommonAPIConstants,
  FilesAPIConstants,
  formatDOSDate,
} from "../utilities/Constants";
import Draggable from "react-draggable";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import ProviderDropdown from "../components/CascadingDropdown";
import { exportExcel } from "../utilities/exportToExcel";
import PrintColumnModal from "../components/PrintColumnModal";

const IntelliBill = () => {
  // const getCurrentDate = () => {
  //   const today = new Date();
  //   const year = today.getFullYear();
  //   const month = String(today.getMonth() + 1).padStart(2, '0');
  //   const day = String(today.getDate()).padStart(2, '0');
  //   return `${year}-${month}-${day}`;
  // };

  const today = new Date();

  const formatCurDate = format(today, "MM/dd/yyyy");

  // Default value for the input is the current date
  // const defaultDate = getCurrentDate();
  const defaultFromDate = new Date("1/1/2015");

  const [isHideChecked, setIsHideChecked] = useState(false);
  const [isClosedClaim, setIsClosedClaim] = useState(false);
  const [updatedTabledata, setUpdatedTableData] = useState([]);
  const [error, setError] = useState(null);
  const [startDate, setStartDate] = useState(formatCurDate, defaultFromDate); // State to store start date
  const [endDate, setEndDate] = useState(formatCurDate); // State to store end date
  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState(formatCurDate, defaultFromDate);

  const [ServiceLocations, setServiceLocations] = useState([]);
  const [selectedCMS33a, setSelectedCMS33a] = useState("0");
  const [selectedCMS33b, setSelectedCMS33b] = useState("0");
  const [selectedBillingNPI, setSelectedBillingNPI] = useState("0");
  const [selectedPracticeProvider, setSelectedPracticeProvider] = useState("0");
  const [selectedProvidersCategory, setSelectedProvidersCategory] =
    useState("0");
  const [selectedSearchFilter, setSelectedSearchFilter] = useState("");
  const [sFilterType, setsFilterType] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("0");
  const [searchByLoaction, setSearchByLocation] = useState("-1");
  const [selectedStatusRadioButton, setSelectedStatusRadioButton] =
    useState("0");
  const [selectedCheckedRadioButton, setSelectedCheckedRadioButton] =
    useState("0");
  const [selectedServiceLocation, setSelectedServicelocation] = useState("0");
  const [selectedFilterProvider, setSelectedFilterProvider] = useState("0");
  const [selectedSuggestion, setSelectedSuggestion] = useState(null);
  const [selectedData, setSelectedData] = useState("");
  const [selectedProviderSuggestion, setSelectedProviderSuggestion] = useState(
    [],
  );
  // const [selectedCPTSuggestion, setSelectedCPTSuggestion] = useState(null);
  // const [filteredData, setFilteredData] = useState([]);

  const [locations, setLocations] = useState([]);
  const [cms33aData, setCMS33aData] = useState([]);
  const [cms33bData, setCMS33bData] = useState([]);
  const [providerCategory, setProviderCategory] = useState([]);
  const [searchFilterData, setSearchFilterData] = useState([]);
  const [practiceProvider, setPracticeProvider] = useState([]);
  const [statusRadioButton, setStatusRadioButton] = useState([]);
  const [checkedRadioButton, setCheckedRadioButton] = useState([]);
  const [selectClearinghouse, setSelectClearingHouse] = useState([]);
  const [ClearingHouse, setClearingHouse] = useState("1");
  const [selectClearingHouseVal, setselectClearingHouseVal] = useState("");
  const [BillingNPIs, setBillingNPIs] = useState([]);
  const [rows, setRows] = useState([]);

  const [searchText, setSearchText] = useState("");
  const [searchPatientText, setSearchPatientText] = useState("");
  const [searchProvidersText, setSearchProvidersText] = useState("");
  // const [ProviderRoleID, setProviderRoleID] = useState('');

  // const [searchInsuranceText, setSearchInsuranceText] = useState('');
  // const [selectedFilter, setSelectedFilter] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [isTextBoxDisabled, setIsTextBoxDisabled] = useState(false);
  const [issuggestionBoxDisabled, setIsSuggestionBoxDisabled] = useState(true);
  const [sPatID, setSPatID] = useState("0");
  const [sClaimStatus, setsClaimStatus] = useState("0");
  const [sCheckedInStatus, setsCheckedInStatus] = useState(0);
  const [rowsValidation, setRowsValidation] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [tableDetails, setTableDetails] = useState([]);
  const [tableInsDetails, setTableInsDetails] = useState([]);
  const [checkEligibility, setCheckEligibility] = useState([]);
  // const [selectedClaims, setSelectedClaims] = useState([]);
  const [selectAllDropDown, setSelectAllDropDown] = useState([]);
  // const [checkboxes, setCheckboxes] = useState();

  const [searchPatientData, setSearchPatientData] = useState([]);
  const [suggestionProviders, setSuggestionProviders] = useState("");
  // const [suggestionInsurance, setSuggestionInsurance] = useState('');
  // const [patientList, setPatientList] = useState('');

  const [activeRow, setActiveRow] = useState(null);

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectClearingHouseRow, setSelectClearingHouseRow] = useState([]);
  const [selectedLocationRows, setSelectedLocationRows] = useState([]);
  // const [selectedValueLocRows, setSelectedValueLocRows] = useState([]);
  const [UnitChargeRows, setUnitChargeRows] = useState([]);
  const [unitCheckbox, setUnitCheckbox] = useState([]);
  const [diag4AllCheckbox, setDiag4AllCheckbox] = useState([]);
  const [diag3AllCheckbox, setDiag3AllCheckbox] = useState([]);
  const [diag2AllCheckbox, setDiag2AllCheckbox] = useState([]);
  const [diag1AllCheckbox, setDiag1AllCheckbox] = useState([]);
  const [mod3AllCheckbox, setMod3AllCheckbox] = useState([]);
  const [mod2AllCheckbox, setMod2AllCheckbox] = useState([]);
  const [mod1AllCheckbox, setMod1AllCheckbox] = useState([]);
  const [cptAllCheckbox, setCptAllCheckbox] = useState([]);
  const [providerAllCheckbox, setProviderAllCheckbox] = useState([]);
  const [insuranceAllCheckbox, setInsuranceAllCheckbox] = useState([]);
  const [closeClaimChecbox, setcloseClaimChecbox] = useState([]);
  const [closeAllClaimCheckbox, setcloseAllClaimCheckbox] = useState(false);
  const [filteredTableDetails, setFilteredTableDetails] =
    useState(tableDetails);
  const [providerDataList, setProviderDataList] = useState([]);
  const [cptDataList, setCptDataList] = useState([]);
  const [modDataList, setModDataList] = useState([]);
  const [mod2DataList, setMod2DataList] = useState([]);
  const [mod3DataList, setMod3DataList] = useState([]);
  const [diag1DataList, setDiag1DataList] = useState([]);
  const [diag2DataList, setDiag2DataList] = useState([]);
  const [diag3DataList, setDiag3DataList] = useState([]);
  const [diag4DataList, setDiag4DataList] = useState([]);
  const [selectedInsRows, setSelectedInsRows] = useState([]);
  const [selectedCPTCode, setSelectedCPTCode] = useState([]);
  const [selectedCPTPatientID, setSelectedCPTPatientID] = useState([]);
  const [selectedPatientID, setSelectedPatientID] = useState([]);
  const [selectedDiag1ID, setSelectedDiag1ID] = useState("");
  const [selectedDiag2ID, setSelectedDiag2ID] = useState("");
  const [selectedDiag3ID, setSelectedDiag3ID] = useState("");
  const [selectedDiag4ID, setSelectedDiag4ID] = useState("");
  // const [newRows, setNewRows] = useState([]);

  const [searchByDOS, setSearchByDOS] = useState("");
  const [searchByPatient, setSearchByPatient] = useState("");
  const [searchByDOB, setSearchByDOB] = useState("");
  const [searchByInsuranceID, setSearchByInsuranceID] = useState("");
  const [searchByProvider, setSearchByProvider] = useState("");
  const [searchByCPT, setSearchByCPT] = useState("");
  const [searchByMod1, setSearchByMod1] = useState("");
  const [searchByMod2, setSearchByMod2] = useState("");
  const [searchByMod3, setSearchByMod3] = useState("");
  const [searchByICD1, setSearchByICD1] = useState("");
  const [searchByICD2, setSearchByICD2] = useState("");
  const [searchByICD3, setSearchByICD3] = useState("");
  const [searchByICD4, setSearchByICD4] = useState("");
  const [searchBySUD, setSearchBySUD] = useState("");

  const [selectedCptValue, setSelectedCptValue] = useState("");
  const [selectedMod1Value, setSelectedMod1Value] = useState("");
  const [selectedMod2ListVal, setSelectedMod2ListVal] = useState("");
  const [selectedMod3ListVal, setSelectedMod3ListVal] = useState("");
  const [selectedDiag1List, setSelectedDiag1List] = useState("");
  const [selectedDiag2List, setSelectedDiag2List] = useState("");
  const [selectedDiag3List, setSelectedDiag3List] = useState("");
  const [selectedDiag4List, setSelectedDiag4List] = useState("");

  const [cptValueList, setCptValueList] = useState([]);
  const [mod1List, setMod1List] = useState([]);
  const [mod2List, setMod2List] = useState([]);
  const [mod3List, setMod3List] = useState([]);
  const [diag1List, setDiag1List] = useState([]);
  const [diag2List, setDiag2List] = useState([]);
  const [diag3List, setDiag3List] = useState([]);
  const [diag4List, setDiag4List] = useState([]);

  // const [selectedUnitVal, setSelectedUnitVal] = useState("");
  const [syncedValue, setSyncedValue] = useState("");
  const [syncedUnitchargeVal, setSyncedUnitchargeVal] = useState("");

  const [selectedProviderText, setSelectedProviderText] = useState("");
  const [selectedCPTList, setSelectedCPTList] = useState("");
  const [selectedModList, setSelectedModList] = useState("");
  const [selectedMod2Value, setSelectedMod2Value] = useState("");
  const [selectedMod3Value, setSelectedMod3Value] = useState("");
  const [selectedDiag1Value, setSelectedDiag1Value] = useState("");
  const [selectedDiag2Value, setSelectedDiag2Value] = useState("");
  const [selectedDiag3Value, setSelectedDiag3Value] = useState("");
  const [selectedDiag4Value, setSelectedDiag4Value] = useState("");
  const [selectedUnitValue, setSelectedUnitValue] = useState("");
  const [selectedUnitChargeValue, setSelectedUnitChargeValue] = useState("");

  const [selectLocationID, setSelectLocationID] = useState("-1");

  const [showSelectErrorModal, setShowSelectErrorModal] = useState(false);
  const [showICDErrorModal, setShowICDErrorModal] = useState(false);
  const [ICDConfirmSaveModal, setICDConfirmSaveModal] = useState(false);

  const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
  const [showApprovalSaveModal, setShowApprovalSaveModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [msgSuccesmodal, setmsgSuccesmodal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteSuccessModal, setDeleteSuccessModal] = useState(false);
  const [closeClaimsModal, setCloseClaimsModal] = useState(false);
  const [showFaxModal, setShowFaxModal] = useState(false);
  const [savedRowCount, setSavedRowCount] = useState(0);
  const [deleteRowCount, setDeleteRowCount] = useState(0);
  const [successTimer, setSuccessTimer] = useState(10000);
  // const [buttonClicked, setButtonClicked] = useState([]);
  // const [showIcon, setShowIcon] = useState(false);
  const [showFaxError, setShowFaxError] = useState(false);
  const [saveFaxError, setSaveFaxError] = useState(false);
  const [showFaxSaveMsg, setShowFaxSaveMsg] = useState(false);
  const [showFaxConfirmMsg, setShowFaxConfirmMsg] = useState(false);

  const [selectedProviderData, setselectedProviderData] = useState("");
  const [selectedMod1Data, setSelectedMod1Data] = useState("");
  const [selectedMod2Data, setSelectedMod2Data] = useState("");
  const [selectedMod3Data, setSelectedMod3Data] = useState("");

  const [selectedInsurances, setSelectedInsurances] = useState({});
  // const [selectedPolicyNumbers, setSelectedPolicyNumbers] = useState({});
  const [policyNumbers, setPolicyNumbers] = useState({});

  const [selectAllRowsChecked, setSelectAllRowsChecked] = useState(false);
  const [selectAllClearingHouseRow, setSelectAllClearingHouseRow] =
    useState(false);
  // const [clearingHouseValues, setClearingHouseValues] = useState({});
  const [savedRows, setSavedRows] = useState([]);
  const [epin, setEpin] = useState("");
  const [verifiedEpin, setverifiedEpin] = useState("");
  const [isEPINVerifiedModal, setIsEPINVerifiedModal] = useState(false);
  // const [verificationError, setVerificationError] = useState(null);
  const [isStartOpen, setIsStartOpen] = useState(false);
  const [isEndOpen, setIsEndOpen] = useState(false);

  // const [selectAllCloseCheckBox, setSelectAllCloseCheckBox] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [isInStatus, setIsInStatus] = useState("");
  // const [policyStatus, setPolicyStatus] = useState({});
  // const [loadingRows, setLoadingRows] = useState([]);
  // const [patientID, setpatientID] = useState('');
  const [rowState, setRowState] = useState({});
  const [claimID, setClaimID] = useState("");
  // const [isHidden, setIsHidden] = useState(false);

  // const [sortDosDate, setSortDosDate] = useState('asc');
  // const [sortPatName, setSortPatName] = useState('asc');
  // const [sortDateOrder, setSortDateOrder] = useState('asc');
  const [practiceProvider1, setPracticeProvider1] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  // const dispatch = useDispatch();
  const rowsPerPage = 200;
  const [visibleRecords, setVisibleRecords] = useState(rowsPerPage);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [showCopaySuccessModal, setShowCopaySuccessModal] = useState(false);
  const [showPrintPopup, setShowPrintPopup] = useState(false);
  const handleCloseClaimModal = () => {
    setCloseClaimsModal(true);
  };
  const insuranceMap = useMemo(() => {
    const map = {};

    tableInsDetails.forEach((ins) => {
      if (!map[ins.PatientId]) {
        map[ins.PatientId] = [];
      }
      map[ins.PatientId].push(ins);
    });

    return map;
  }, [tableInsDetails]);

  const handleCheckeligibility = async (e, rowIndex) => {
    if (insuranceAllCheckbox.length === 0) {
      setShowSelectErrorModal(true);
      return;
    }

    const rowId = insuranceAllCheckbox[0];
    const item = filteredTableDetails.find((row) => row.CPTRowID === rowId);
    if (!item) return;
    const currentClaimId = item.ClaimId;
    setClaimID(currentClaimId);
    setShowSelectErrorModal(false);
    setIsLoading(true);

    const inputStruct = {
      PatientID: item.PatientId,
      PracticeID: userPracticeID,
      PolicyNumber: item.PolicyNumber + "",
      DOS: item.DOS,
      RowIndex: rowId,
    };
    const objPatientDetails = { objPatientDetails: inputStruct };
    const myInput = JSON.stringify(objPatientDetails);
    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientEligibility}?sInputJSON=${myInput}`;

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status != 200) {
          console.log("response.status", response.status);
        } else return response.json();
      })

      .then((data) => {
        const responseData = data;
        const parsedData = JSON.parse(responseData);

        setRowState((prevState) => ({
          ...prevState,
          [currentClaimId]: {
            isLoading: false,
            isHidden: false,
            showIcon: true,
          },
        }));

        setCheckEligibility(parsedData);

        var RowIndex = parsedData.RowIndex;
        // var InsStatus = parsedData.InsStatus;
        setIsInStatus(parsedData.InsStatus);
        // var EligibilityError = parsedData.EligibilityError;

        const payerIDElement = document.querySelector(`.payer${RowIndex}`);

        const filteredClaims = filteredTableDetails.filter((item) => {
          if (item.ClaimId == claimID) {
            if (payerIDElement) {
              if (parsedData.InsStatus === "Active") {
                payerIDElement.style.color = "green";
              } else {
                payerIDElement.style.color = "red";
              }
            }
          }

          return true;
        });

        setFilteredTableDetails(filteredClaims);
      })
      .catch((error) => {
        console.error("An error occurred:", error);

        setRowState((prevState) => ({
          ...prevState,
          [claimID]: { isLoading: false, isHidden: false, showIcon: true },
        }));
      });
  };




  const GetPDFCMS = (item) => {

    const claimFilters = {

      PracticeID: userPracticeID,
      ClaimID: item.ClaimId,
      PatientID: item.PatientId,

    };


    const sInputJSON = JSON.stringify(claimFilters);



    const url = `${APIConstants.BASE_URL_BILLING}${CommonAPIConstants.GetPDFCMS1500}?sInputJSON=${sInputJSON}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then(response => response.json()) // Parse the response as JSON
      .then(data => {
        console.log('API response:' + CommonAPIConstants.GetPDFCMS1500, data);
        if (data && data) {

          const parsedData = JSON.parse(data);
          const url = parsedData.DocumentURL
          window.open(url, '_blank');


        }
      })
      .catch(error => {
        console.error(' PDF failed', error);
      });
  };


  const handleAllClearinghouseChange = (e) => {
    const selectedValue = e.target.value;
    setselectClearingHouseVal(selectedValue);

    for (const curIndex of selectClearingHouseRow) {
      const item = tableDetails[curIndex];
      item.ClearingHouse = selectedValue;
    }
  };
  const handleSelectChange = (e) => {
    const { value } = e.target;
    setSelectedServicelocation(value);
    for (const curIndex of selectedLocationRows) {
      const item = tableDetails[curIndex];
      item.ServiceLocationCode = value;
    }
  };
  const handleICDOpenModal = () => {
    if (
      diag1AllCheckbox.length === 0 &&
      diag2AllCheckbox.length === 0 &&
      diag3AllCheckbox.length === 0 &&
      diag4AllCheckbox.length === 0
    ) {
      setShowICDErrorModal(true);
    } else {
      setICDConfirmSaveModal(true);
    }
  };
  const openPrintPopup = () => {
    const initial = {};
    columns.forEach(col => {
      initial[col.key] = true;
    });

    setPrintColumnVisibility(initial);
    setShowPrintPopup(true);
  };
  const togglePrintColumn = (key) => {
    setPrintColumnVisibility(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };
  const columns = [
    { key: "#", label: "#", minWidth: "30px", render: (_, idx) => idx + 1 },

    {
      key: "AppLocationName",
      label: "Location",
      isLink: true,
      render: (item) => <label>{item.AppLocationName}</label>,
    },

    {
      key: "DOS",
      label: "DOS",
      isLink: true,
      hasSearch: true,
      searchValue: searchByDOS,
      setSearchValue: setSearchByDOS,
      render: (item) => (
        <label className="linkspan" onClick={() => handleDosLinkClick(item)}>
          {item.DOS}
        </label>
      ),
    },

    {
      key: "PatientName",
      label: "Patient Name(2)",
      isLink: true,
      hasSearch: true,
      searchValue: searchByPatient,
      setSearchValue: setSearchByPatient,
      render: (item) => (
        <>
          <label
            className={`linkspan ${item.EligibilityCheckCount > 0
              ? "EligibilityChecked"
              : "EligibilityNotChecked"
              }`}
            onClick={() => handlePatLinkClick(item)}
            title={item.PatientName}
          >
            {item.PatientName}
          </label>
          {item.PatSecInscount > 0 && (
            <span>
              <FontAwesomeIcon
                className="show-icon"
                style={{ marginLeft: "10px" }}
                icon={faShieldHalved}
              />
            </span>
          )}
        </>
      ),
    },

    {
      key: "ProviderDisplay",
      label: "BH/SUD",
      hasSearch: true,
      searchValue: searchBySUD,
      setSearchValue: setSearchBySUD,
      render: (item) =>
        item.ProviderRoleID === 1 ? (
          <label>{item.ScheduleType}</label>
        ) : item.ProviderRoleID === 9 ? (
          <label>{item.CouAppType}</label>
        ) : (
          ""
        ),
    },

    {
      key: "DOB",
      label: "DOB(3)",
      hasSearch: true,
      searchValue: searchByDOB,
      setSearchValue: setSearchByDOB,
      render: (item) => <label>{item.DOB}</label>,
    },

    {
      key: "SelectedInsuranceName",
      label: "Insurance (1a)",
      isLink: true,
      hasSearch: true,
      searchValue: searchByInsuranceID,
      setSearchValue: setSearchByInsuranceID,

      hasCheckbox: true,
      checkboxValue: closeAllClaimCheckbox,
      onCheckboxChange: (e) => handleCloseClaimAllChange(e.target.checked),

      hasButton: true,
      buttons: [
        {
          label: "Close",
          className: "btn-style2 hide-on-print",
          onClick: handleCloseClaimModal,
        },
        {
          label: "Check",
          className: "btn-style3 hide-on-print",
          onClick: handleCheckeligibility,
        },
      ],
      headerExtra: (
        <input
          style={{ marginLeft: "3px" }}
          type="checkbox"
          className="hide-on-print"
          onChange={() => handleSelectInsuranceAllChange("all")}
        />
      ),
      render: (item, index, filteredInsDetails) => {
        const rowId = item.CPTRowID;
        const selectedInsId = selectedInsurances[rowId];
        const selectedInsurance = tableInsDetails.find(
          (ins) => String(ins.InsId) === String(selectedInsId),
        );
        return (
          <>
            {policyNumbers[rowId] ? (
              <label
                className={`payer${rowId}`}
                style={{
                  color: item.PatInsStatus === "Active" ? "green" : "red",
                }}
              >
                {policyNumbers[rowId]}
              </label>
            ) : (
              <label className="label-style"></label>
            )}
            <br />
            {filteredInsDetails.length > 0 ? (
              <>
                <select
                  className="hide-on-print"
                  style={{ width: "100px" }}
                  value={selectedInsId || ""}
                  onChange={(e) => handleInsuranceChange(item, e.target.value)}
                >
                  {filteredInsDetails
                    .filter((ins) => ins.InsId && ins.InsureranceCompanyname)
                    .map((ins) => (
                      <option key={ins.InsId} value={ins.InsId}>
                        {ins.InsureranceCompanyname}
                      </option>
                    ))}
                </select>
                <span className="show-on-print">
                  {selectedInsurance?.InsureranceCompanyname || ""}
                </span>
              </>
            ) : (
              <select
                className="hide-on-print"
                style={{ width: "100px" }}
              ></select>
            )}
            <br />
            <input
              style={{ float: "right", marginRight: "10px", marginTop: "6px" }}
              type="checkbox"
              className="hide-on-print"
              checked={insuranceAllCheckbox.includes(rowId)}
              onChange={() => handleInsuranceRowCheckbox(item)}
            />
            <FontAwesomeIcon
              className="hide-on-print"
              style={{ color: "red", fontSize: "8px" }}
              icon={faStar}
            />
            {rowState[item.ClaimId]?.isHidden && (
              <FontAwesomeIcon
                style={{ marginLeft: "5px" }}
                icon={faSpinner}
                className={
                  rowState[item.ClaimId]?.isLoading ? "rotating-icon" : ""
                }
              />
            )}
            {!rowState[item.ClaimId]?.showIcon && (
              <FontAwesomeIcon
                className={
                  rowState[item.ClaimId]?.isLoading
                    ? ""
                    : "faexclamation-icon hide-on-print"
                }
                icon={faTriangleExclamation}
              />
            )}
            <input
              style={{ marginTop: "5px", marginLeft: "3px" }}
              type="checkbox"
              className="hide-on-print"
              checked={closeClaimChecbox.includes(rowId)}
              onChange={(e) =>
                handleCloseClaimCheckboxChange(rowId, item, e.target.value)
              }
              disabled={item.PrimaryIns !== 281}
            />
          </>
        );
      },
    },

    {
      key: "ProvderName",
      label: "Rendering Provider (24 J)",
      hasSearch: true,
      searchValue: searchByProvider,
      setSearchValue: setSearchByProvider,
      headerCheckbox: {
        onChange: () => handleSelectProviderAllChange("all"),
      },
      render: (item, idx) => (
        <>
          <label>{item.ProvderName}</label>
          <FontAwesomeIcon
            className="hide-on-print"
            style={{ marginLeft: "5px", color: "red", cursor: "pointer" }}
            onClick={() => GetProviderPDF(item)}
            icon={faFilePdf}
          />
          <input
            type="checkbox"
            checked={providerAllCheckbox.includes(idx)}
            onChange={() => handleProviderRowCheckboxChange(idx, item)}
          />
        </>
      ),
    },

    {
      key: "CPT",
      label: "CPT (24 D)",
      hasSearch: true,
      searchValue: searchByCPT,
      setSearchValue: setSearchByCPT,
      headerCheckbox: {
        onChange: () => handleSelectCPTAllChange("all"),
      },
      render: (item, idx) => (
        <>
          <label>{item.CPT}</label>
          <input
            type="checkbox"
            checked={cptAllCheckbox.includes(idx)}
            onChange={() => handleCPTRowCheckboxChange(idx)}
          />
        </>
      ),
    },

    {
      key: "Mod1",
      label: "Mod1",
      hasSearch: true,
      headerCheckbox: {
        onChange: () => handleSelectMod1AllChange("all"),
      },
      searchValue: searchByMod1,
      setSearchValue: setSearchByMod1,
      render: (item, idx) => (
        <>
          <label>{item.Mod1}</label>
          <input
            type="checkbox"
            checked={mod1AllCheckbox.includes(idx)}
            onChange={() => handleMod1RowCheckboxChange(idx)}
          />
        </>
      ),
    },

    {
      key: "Mod2",
      label: "Mod2",
      hasSearch: true,
      headerCheckbox: {
        onChange: () => handleSelectMod2AllChange("all"),
      },
      searchValue: searchByMod2,
      setSearchValue: setSearchByMod2,
      render: (item, idx) => (
        <>
          <label>{item.Mod2}</label>
          <input
            type="checkbox"
            checked={mod2AllCheckbox.includes(idx)}
            onChange={() => handleMod2RowCheckboxChange(idx)}
          />
        </>
      ),
    },

    {
      key: "Mod3",
      label: "Mod3",
      hasSearch: true,
      headerCheckbox: {
        onChange: () => handleSelectMod3AllChange("all"),
      },
      searchValue: searchByMod3,
      setSearchValue: setSearchByMod3,
      render: (item, idx) => (
        <>
          <label>{item.Mod3}</label>
          <input
            type="checkbox"
            checked={mod3AllCheckbox.includes(idx)}
            onChange={() => handleMod3RowCheckboxChange(idx)}
          />
        </>
      ),
    },
    {
      key: "ICDCode",
      label: "Diag1",
      hasSearch: true,
      headerCheckbox: {
        onChange: () => handleSelectDiag1AllChange("all"),
      },
      headerExtra: (
        <FontAwesomeIcon
          className="hide-on-print"
          style={{ cursor: "pointer", marginLeft: "5px" }}
          onClick={handleICDOpenModal}
          icon={faTrashCan}
        />
      ),
      searchValue: searchByICD1,
      setSearchValue: setSearchByICD1,
      render: (item, idx) => (
        <>
          
          <label title={
              item.ICD1billable == 0
                ? "Invalid ICD. Claim will be rejected"
                : ""}>{item.ICDCode}</label>
          <input
            type="checkbox"
            checked={diag1AllCheckbox.includes(idx)}
            onChange={() => handleDiag1RowCheckboxChange(idx)}
          />
        </>
      ),
    },
    {
      key: "ICDCode2",
      label: "Diag2",
      hasSearch: true,
      headerCheckbox: {
        onChange: () => handleSelectDiag2AllChange("all"),
      },
      headerExtra: (
        <FontAwesomeIcon
          className="hide-on-print"
          style={{ cursor: "pointer", marginLeft: "5px" }}
          onClick={handleICDOpenModal}
          icon={faTrashCan}
        />
      ),
      searchValue: searchByICD2,
      setSearchValue: setSearchByICD2,
      render: (item, idx) => (
        <>
          <label title={
              item.ICD2billable == 0
                ? "Invalid ICD. Claim will be rejected"
                : ""}>{item.ICDCode2}</label>
          <input
            type="checkbox"
            checked={diag2AllCheckbox.includes(idx)}
            onChange={() => handleDiag2RowCheckboxChange(idx)}
          />
        </>
      ),
    },
    {
      key: "ICDCode3",
      label: "Diag3",
      hasSearch: true,
      headerCheckbox: {
        onChange: () => handleSelectDiag3AllChange("all"),
      },
      headerExtra: (
        <FontAwesomeIcon
          className="hide-on-print"
          style={{ cursor: "pointer", marginLeft: "5px" }}
          onClick={handleICDOpenModal}
          icon={faTrashCan}
        />
      ),
      searchValue: searchByICD3,
      setSearchValue: setSearchByICD3,
      render: (item, idx) => (
        <>
          <label title={
              item.ICD3billable == 0
                ? "Invalid ICD. Claim will be rejected"
                : ""}>{item.ICDCode3}</label>
          <input
            type="checkbox"
            checked={diag3AllCheckbox.includes(idx)}
            onChange={() => handleDiag3RowCheckboxChange(idx)}
          />
        </>
      ),
    },
    {
      key: "ICDCode4",
      label: "Diag4",
      hasSearch: true,
      headerCheckbox: {
        onChange: () => handleSelectDiag4AllChange("all"),
      },
      headerExtra: (
        <FontAwesomeIcon
          className="hide-on-print"
          style={{ cursor: "pointer", marginLeft: "5px" }}
          onClick={handleICDOpenModal}
          icon={faTrashCan}
        />
      ),
      searchValue: searchByICD4,
      setSearchValue: setSearchByICD4,
      render: (item, idx) => (
        <>
          <label title={
              item.ICD4billable == 0
                ? "Invalid ICD. Claim will be rejected"
                : ""}>{item.ICDCode4}</label>
          <input
            type="checkbox"
            checked={diag4AllCheckbox.includes(idx)}
            onChange={() => handleDiag4RowCheckboxChange(idx)}
          />
        </>
      ),
    },

    {
      key: "Unit",
      label: "Unit (24 G)",
      headerCheckbox: {
        onChange: () => handleSelectUnitAllChange("all"),
      },
      render: (item) => (
        <>
          <label className="show-on-print">{item.Unit}</label>
          <input
            type="number"
            className="text-boxes hide-on-print"
            value={item.Unit ?? ""}
            onChange={(e) =>
              handleUnitChange(item.CPTRowID, e.target.value)
            }
          />
          <input
            type="checkbox"
            checked={unitCheckbox.includes(item.CPTRowID)}
            onChange={() =>
              handleUnitRowCheckboxChange(item.CPTRowID)
            }
          />
        </>
      ),
    },

    {
      key: "Unitcharge",
      label: "Unit Charge (24 F)",
      headerCheckbox: {
        onChange: () => handleUnitChargeAllChange(),
      },
      render: (item) => (
        <>
          <label className="show-on-print">
            {item.Unitcharge}
          </label>
          <input
            type="number"
            className="text-boxes hide-on-print"
            value={item.Unitcharge ?? ""}
            onChange={(e) =>
              handleUnitchargeChange(
                item.CPTRowID,
                e.target.value
              )
            }
          />
          <input
            type="checkbox"
            checked={UnitChargeRows.includes(
              item.CPTRowID
            )}
            onChange={() =>
              handleUnitChargeRowCheckbox(
                item.CPTRowID
              )
            }
          />
        </>
      ),
    },

    {
      key: "TotalCharge",
      label: "Total Charge",
      render: (item, idx) => (
        <input
          className="text-boxes hide-on-print"
          type="number"
          value={item.TotalCharge || ""}
          onChange={(e) => handleTotalChargeChange(idx, e.target.value)}
        />
      ),
    },

    {
      key: "CopayAmount",
      label: "Copay",
      render: (item) => (
        <>
          {item.CopayAppliedClaim === 0 || item.CopayAppliedClaim === "" ? (
            <button
              className="btn-style3"
              onClick={() => handleApplyCopayData(item)}
            >
              {item.CopayAmount}
            </button>
          ) : (
            <button
              className="btngrey"
              title={`Copay applied to claim ${item.CopayAppliedClaim}`}
            >
              {item.CopayAmount}
            </button>
          )}
        </>
      ),
    },

    {
      key: "ClaimId",
      label: "Claim ID",
      render: (item) => (
        <div
          style={{
            width: "100px",
            backgroundColor:
              item.UpdatedBy && item.UpdatedDateTime ? "lightpink" : "",
          }}
        >
          <span
            onClick={() => handleLinkClick(item)}
            style={{
              cursor: "pointer",
              textDecoration: "underline",
              color: "blue",
            }}
            title={`Claim ID: ${item.ClaimId}`}
          >
            {item.ClaimId}
          </span>

          {item.docWebPath && item.docWebPath.trim() !== "" ? (

            <FontAwesomeIcon
              style={{ marginLeft: "10px", color: "red", cursor: "pointer" }}
              onClick={() => GetPDFCMS(item)}
              icon={faFilePdf}
            />
          ) : (

            <FontAwesomeIcon
              style={{ marginLeft: "10px", color: "black" }}
              icon={faCircleInfo}
              title="CMS 1500 not present"
            />
          )}
          {item.Status === "" && item.ClaimId !== 0 && (
            <FontAwesomeIcon
              className="hide-on-print ml-2"
              style={{ color: "red", fontSize: "8px" }}
              icon={faStar}
            />
          )}

          <br />


        </div >
      ),
    },

    {
      key: "ClearingHouse",
      label: "Clearing House",
      hasSelect: true,
      headerCheckbox: {
        onChange: () => handleAllClearingHouseRow("all"),
      },
      selectValue: selectClearingHouseVal,
      selectOptions: selectClearinghouse.map((ch) => ({
        value: ch.MCHID,
        label: ch.ClearingHouseName,
      })),
      onSelectChange: handleAllClearinghouseChange,
      render: (item, idx) => {
        const ch = selectClearinghouse.find(c => c.MCHID == item.ClearingHouse);
        return (
          <>
            <select
              value={item.ClearingHouse}
              onChange={(e) => handleClearinghouseChange(idx, e)}
              className="hide-on-print"
            >
              {selectClearinghouse.map((ch) => (
                <option key={ch.MCHID} value={ch.MCHID}>
                  {ch.ClearingHouseName}
                </option>
              ))}
            </select>
            <span className="show-on-print">
              {ch?.ClearingHouseName || ""}
            </span>
            <input
              type="checkbox"
              checked={selectClearingHouseRow.includes(idx)}
              onChange={() => handleClearingRowCheckboxChange(idx, item)}
              className="hide-on-print"
            />
          </>
        );
      }
    },

    {
      key: "ServiceLocationCode",
      label: "Service Loc(24 B)",
      hasSelect: true,
      headerCheckbox: {
        onChange: () => handleSelectLocationAllChange("all"),
      },
      selectValue: selectedServiceLocation,
      selectOptions: ServiceLocations.map((sl) => ({
        value: sl.ID,
        label: sl.PlaceOfService,
      })),
      onSelectChange: handleSelectChange,
      render: (item, idx) => {
        const loc = ServiceLocations.find(
          sl => sl.ID == item.ServiceLocationCode
        );

        return (
          <>
            <select value={item.ServiceLocationCode} className="hide-on-print">
              {ServiceLocations.map((sl) => (
                <option key={sl.ID} value={sl.ID}>
                  {sl.PlaceOfService}
                </option>
              ))}
            </select>
            <span className="show-on-print">
              {loc?.PlaceOfService || ""}
            </span>
            <input
              type="checkbox"
              checked={selectedLocationRows.includes(idx)}
              onChange={() => handleLocRowCheckboxChange(idx, item)}
              className="hide-on-print"
            />
          </>
        );
      }
    },

    {
      key: "Select",
      label: "Select",
      headerCheckbox: {
        onChange: () => handleSelectAllChange("all"),
      },
      render: (item, idx) => (
        <>
          <div className="hide-on-print" style={{ width: "80px" }}>
            {item.isReadyforApproval == 1 ? (
              <FontAwesomeIcon icon={faCheckCircle} className="text-green-300" />
            ) : (
              <input
                type="checkbox"
                checked={selectedRows.some((row) => row.index === idx)}
                disabled={!(item?.Status === "" || item?.Status === null)}
                onChange={() => handleRowCheckboxChange(idx, item)}
              />
            )}
          </div>
          <span className="show-on-print">
            {item.isReadyforApproval == 1 ? "Approved" : ""}
          </span>
        </>
      ),
    },
  ];
  const [selectedColumns, setSelectedColumns] = useState(
    columns.map((col) => col.key),
  );
  const [printColumnVisibility, setPrintColumnVisibility] = useState(
    Object.fromEntries(columns.map(col => [col.key, true]))
  );
  const handleSelectAll = () => {
    const updated = {};
    columns.forEach(col => {
      updated[col.key] = true;
    });

    setPrintColumnVisibility(updated);
  };
  const handleDeselectAll = () => {
    const updated = {};
    columns.forEach(col => {
      updated[col.key] = false;
    });

    setPrintColumnVisibility(updated);
  };
  const allSelected = columns.every(col => printColumnVisibility[col.key]);
  const noneSelected = columns.every(col => !printColumnVisibility[col.key]);
  // const tableContainerRef = useRef(null);
  const loadMoreRecords = useCallback(() => {
    setVisibleRecords((prev) => {
      const next = Math.min(prev + rowsPerPage, filteredTableDetails.length);

      if (next > prev) {
        setPopupMessage(
          `${next} records out of ${filteredTableDetails.length} loaded`,
        );
        setShowPopup(true);

        setTimeout(() => {
          setShowPopup(false);
        }, 3000);
      }

      return next;
    });
  }, [filteredTableDetails.length]);

  const handleScroll = useCallback(() => {
    const isAtBottom =
      window.innerHeight + window.scrollY >=
      document.documentElement.scrollHeight;

    if (isAtBottom) {
      loadMoreRecords();
    }
  }, [loadMoreRecords]);

  useEffect(() => {
    setVisibleRecords(rowsPerPage);
  }, [filteredTableDetails]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const userData = useSelector((state) => state.user.user);

  localStorage.setItem("userData", JSON.stringify(userData));

  var userPracticeID = userData ? userData.practiceID : null;

  var userId = userData ? userData.userID : null;

  const sAuthToken = useSelector((state) => state.user.token);

  useEffect(() => {
    document.title = "Intellibill";

    let timerId;

    if (
      showSuccessModal ||
      deleteSuccessModal ||
      msgSuccesmodal ||
      isEPINVerifiedModal ||
      showCopaySuccessModal
    ) {
      // Start the timer when the success modal is shown
      timerId = setTimeout(() => {
        setShowSuccessModal(false);
        setDeleteSuccessModal(false);
        setmsgSuccesmodal(false);
        setIsEPINVerifiedModal(false);
        setShowCopaySuccessModal(false);
      }, successTimer);
    }

    return () => {
      clearTimeout(timerId);
    };
  }, [
    showSuccessModal,
    successTimer,
    deleteSuccessModal,
    msgSuccesmodal,
    isEPINVerifiedModal,
    showCopaySuccessModal,
  ]);

  const handleFromDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, "MM/dd/yyyy");
      setFromDate(formattedDate);
    } else {
      setFromDate(null);
    }
  };

  const handleStartDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, "MM/dd/yyyy");
      setStartDate(formattedDate);
      setEndDate(formattedDate);
      setIsStartOpen(false);
    } else {
      setStartDate(null);
    }
  };

  const handleEndDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, "MM/dd/yyyy");
      setEndDate(formattedDate);
      setIsEndOpen(false);
    } else {
      setEndDate(null);
    }
  };

  const getMonths = (selectedYear) => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();

    return Array.from({ length: 12 }, (v, k) => {
      if (selectedYear === currentYear && k > currentMonth) {
        return null;
      }
      return (
        <option key={k} value={k}>
          {format(new Date(selectedYear, k), "MMMM")}
        </option>
      );
    }).filter((option) => option !== null);
  };

  const handleStartDoneClick = () => {
    setIsStartOpen(false);
  };

  const handleTodayClick = (dateType) => {
    const today = new Date();

    if (dateType === "start" && startDate) {
      setStartDate(today);
      setEndDate(today);
      setIsStartOpen(false);
    }

    if (dateType === "end" && endDate) {
      setEndDate(today);
      setIsEndOpen(false);
    }
  };

  const CalendarContainer = ({ children }) => (
    <div
      style={{
        zIndex: "99px",
        backgroundColor: "white",
        border: "1px solid lightgray",
      }}
    >
      {children}
      <div
        style={{
          justifyContent: "center",
          padding: "10px",
          borderTop: "1px solid #ddd",
          marginLeft: "65px",
        }}
      >
        <button
          type="button"
          className="today-btn"
          onClick={() => handleTodayClick("end")}
        >
          Today
        </button>
      </div>
    </div>
  );

  const CalendarStartContainer = ({ children }) => (
    <div
      style={{
        zIndex: "99px",
        backgroundColor: "white",
        border: "1px solid lightgray",
      }}
    >
      {children}
      <div
        style={{
          justifyContent: "center",
          padding: "10px",
          borderTop: "1px solid #ddd",
          marginLeft: "65px",
        }}
      >
        <button
          type="button"
          className="today-btn"
          onClick={() => handleTodayClick("start")}
        >
          Today
        </button>
      </div>
    </div>
  );

  const convertDateFormat = (dateString) => {
    const [year, month, day] = dateString.split("-");
    return `${month}/${day}/${year}`;
  };

  const handleHideCheckboxChange = () => {
    setIsHideChecked(!isHideChecked);

    if (isHideChecked) {
      // Reset to original dates
      setStartDate(formatCurDate);
      setEndDate(formatCurDate);
    } else {
      // Set FROM date to 1/1/2015 and TO date to the current date
      setStartDate("01/1/2024");
      setEndDate(formatCurDate);
    }
  };

  const handleCloseClaimCheckbox = () => {
    setIsClosedClaim(!isClosedClaim);
  };

  useEffect(() => {
    getProvider();
  }, [userData]);

  const getProvider = () => {
    const url =
      APIConstants.COMMON_BASE_URL +
      `CommonData/BillingProviders?sInputJSON={"PracticeID":"${userPracticeID}"}`;
    const response = fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${sAuthToken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setPracticeProvider(data);
      })

      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };

  // Api Integration of all Dropdowns

  useEffect(() => {
    const url = `${APIConstants.COMMON_BASE_URL}${IntelliBillConstants.GetIntelliDropDowns}?sInputJSON={PracticeID:${userPracticeID},UserId:${userId} }`;

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status != 200) {
          console.log("response.status", response.status);
        } else return response.json();
      })

      .then((data) => {
        // Extract the relevant data from the response
        const parsedData = JSON.parse(data);

        setSelectAllDropDown(parsedData);

        // Populate the dropdowns with the received data
        setLocations(JSON.parse(parsedData.LocationDetails));

        setCMS33aData(JSON.parse(parsedData.CMSbox33aData));
        setCMS33bData(JSON.parse(parsedData.CMSbox33bData));
        setBillingNPIs(JSON.parse(parsedData.PracticeBillingNPIs));
        setServiceLocations(JSON.parse(parsedData.ServiceLocation));
        setPracticeProvider1(JSON.parse(parsedData.PracticeProviders));
        setProviderCategory(JSON.parse(parsedData.ProvidersCategories));
        setSearchFilterData(JSON.parse(parsedData.SearchByFilters));
        setStatusRadioButton(JSON.parse(parsedData.StatusRadioButtons));
        setCheckedRadioButton(JSON.parse(parsedData.CheckedInRadioButtons));
        setLoading(false);
      })

      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  }, [userData]);

  const filteredOptions = ServiceLocations.filter(
    (option) => option.ID !== "0",
  );

  useEffect(() => {
    // Reset values when showFaxDialog is true
    if (showFaxModal) {
      setRows([]);
      resetDialogValues();
    }
  }, [showFaxModal]);

  const resetDialogValues = () => {
    // startDate('');
    setSelectedProviderText("");
    setSelectedCPTList("");
    setSelectedModList(null);
    setSelectedUnitValue("");
    setSelectedUnitChargeValue("");
    setSelectedDiag1Value("");
    setSelectedDiag2Value("");
    setSelectedDiag3Value("");
    setSelectedDiag4Value("");
    setSelectedMod2Value("");
    setSelectedMod3Value("");
    setSaveFaxError(false);
    setShowFaxError(false);
    setShowFaxSaveMsg(false);
  };

  const handleLocationChange = (e, item) => {
    const newSelectedLocation = e.target.value;
    setSearchByLocation(newSelectedLocation || item.LocationId);
    setSelectLocationID(newSelectedLocation);

    localStorage.setItem("selectedLocation", newSelectedLocation);
  };

  const handleSuggestionSelect = (item) => {
    setSearchText(item.label);

    setSelectedData(item.label);

    setSuggestions([]);

    setSPatID(item.val);
  };

  const handleInputKeyPress = (event) => {
    if (event.key === "Backspace") {
      // Handle backspace key
      if (searchText === "" && suggestions.length > 0) {
        setSuggestions([]);
        setSPatID("");
      } else {
        // Remove the last character from searchText
        const updatedSearchText = searchText.slice(0, -1);
        setSearchText(updatedSearchText);

        // Fetch suggestions based on the selected search filter
        fetchSuggestions(updatedSearchText);
      }
    } else if (event.key !== "Enter") {
      // Handle other key presses
      setSearchText(event.target.value);
      fetchSuggestions(event.target.value);
    }
  };

  const fetchSuggestions = (text) => {
    setSPatID("");

    if (selectedSearchFilter === "Pat") {
      fetchPatientNames(text);
    } else if (selectedSearchFilter === "Insurance") {
      fetchInsuranceCompanies(text);
    } else if (selectedSearchFilter === "Provider") {
      fetchProviders(text);
    } else if (selectedSearchFilter === "" && searchText === "") {
      setSPatID("");
      handleTableDataClick();
    }
  };

  useEffect(() => {
    setIsTextBoxDisabled(selectedSearchFilter === "");

    setSearchText("");
    setSPatID("");
  }, [selectedSearchFilter]);

  const fetchPatientNames = () => {
    var inputJSON = {
      PracticeID: userPracticeID,
      SearchKey: searchText,
      SearchBy: 0,
      isFromLogin: 0,
    };

    var sJSONInput = JSON.stringify(inputJSON);

    const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllPatientNames}?sJSONInput=${sJSONInput}`;

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status != 200) {
          console.log("response.status", response.status);
        } else return response.json();
      })
      .then((data) => {
        const parsedData = JSON.parse(data);
        const patientData = parsedData.Data;

        if (Array.isArray(patientData)) {
          setSuggestions(
            patientData.map((item) => ({
              label: `${item.LastName}, ${item.FirstName}`,
              val: item.PatientID,
            })),
          );
        } else {
          setSuggestions([]);
          setIsTextBoxDisabled(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching patient names:", error);
      });
  };

  const fetchSuggestionPatientNames = () => {
    if (!setSearchPatientText) {
      setSearchPatientData([]);
      return;
    }

    var inputJSON = {
      PracticeID: userPracticeID,
      SearchKey: searchPatientText,
      SearchBy: 0,
      isFromLogin: 0,
    };

    var sJSONInput = JSON.stringify(inputJSON);
    const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllPatientNames}?sJSONInput=${sJSONInput}`;
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status != 200) {
          console.log("response.status", response.status);
        } else return response.json();
      })
      .then((data) => {
        const parsedData = JSON.parse(data);

        const patientData = parsedData.Data;

        if (Array.isArray(patientData)) {
          setSearchPatientData(
            patientData.map((item) => ({
              label: `${item.LastName}, ${item.FirstName}`,
              val: item.PatientID,
            })),
          );

          setSelectedCPTPatientID(patientData.val);
        } else {
          setSearchPatientData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching patient names:", error);
      });
  };

  const isMounted = useRef(true);

  useEffect(() => {
    if (isMounted.current) {
      isMounted.current = false;
    } else {
      fetchSuggestionPatientNames(searchPatientText);
    }
  }, [searchPatientText]);

  const handlePatientSuggestion = (suggestion) => {
    setSearchPatientText(`${suggestion.label}`);
    setSelectedSuggestion(suggestion.label);
    setSelectedCPTPatientID(suggestion.val);
    setSearchPatientData([]);
    setShowFaxModal(true);
    setSelectedPatientID(suggestion.val);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Backspace") {
      // Handle backspace key
      if (searchPatientText === "" && searchPatientData.length > 0) {
        setSearchPatientData([]);
      } else {
        fetchSuggestionPatientNames(searchPatientText.slice(0, -1)); // Remove the last character from searchText
      }
    }
  };

  const fetchProviders = () => {
    var inputStruct = {
      sProviderName: searchText,
      sPracticeID: userPracticeID,
      LoggedInUserDetails: userData,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + IntelliBillConstants.GetIntelliProvidersNames,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const providersData = parsedData.Data;

        if (Array.isArray(providersData)) {
          setSuggestions(
            providersData.map((item) => ({
              label: item.split("$")[0].split("|")[1].trim(),
              val: item.split("$")[1].trim(),
            })),
          );
        } else {
          setSuggestions([]);
          setIsTextBoxDisabled(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching provider names:", error);
      });
  };

  const fetchSearchProviders = () => {
    if (!selectedProviderData) {
      // If searchText is empty, you may want to reset or clear any existing data
      setSearchPatientData([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }

    for (const rowIndex of providerAllCheckbox) {
      const item = tableDetails[rowIndex];

      item.ProvderName = selectedProviderData;
    }

    var inputStruct = {
      sProviderName: selectedProviderData,
      sPracticeID: userPracticeID,
      LoggedInUserDetails: userData,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + IntelliBillConstants.GetIntelliProvidersNames,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const providersData = parsedData.Data;

        if (Array.isArray(providersData)) {
          setSuggestionProviders(
            providersData.map((item) => ({
              label: item.split("$")[0].split("|")[1].trim(),
              val: item.split("$")[1].trim(),
            })),
          );
        } else {
          setSuggestionProviders([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching provider names:", error);
      });
  };

  useEffect(() => {
    // Fetch suggestions when the component mounts or when searchText changes

    fetchSearchProviders(selectedProviderData);
  }, [selectedProviderData]);

  const handleProviderSuggestion = (suggestion) => {
    setSearchProvidersText(suggestion.label);

    setselectedProviderData(suggestion.label);
    setSearchProvidersText(suggestion.val);
    setSuggestionProviders([]);
  };

  const handleProviderKeyDown = (e) => {
    if (e.key === "Backspace") {
      // Handle backspace key
      if (selectedProviderData === "" && suggestionProviders.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setSuggestionProviders([]);
      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchSearchProviders(selectedProviderData.slice(0, -1)); // Remove the last character from searchText
      }
    }
  };

  const fetchInsuranceCompanies = () => {
    var inputJSON = {
      SearchKey: searchText,
    };

    var sJSONInput = JSON.stringify(inputJSON);
    const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetInsuCompanyNames}?sJSONInput=${sJSONInput}`;

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status != 200) {
          console.log("response.status", response.status);
        } else return response.json();
      })
      .then((data) => {
        const parsedData = JSON.parse(data);

        const InsuranceData = parsedData.Data;

        if (Array.isArray(InsuranceData)) {
          const filteredSuggestions = InsuranceData.map((item) => ({
            label: item.Insurance,
            val: item.InsuID,
          })).filter(
            (item) => item.label !== selectedData && item.label !== "",
          );

          setSuggestions(filteredSuggestions);
        } else {
          setSuggestions([]);
          setIsTextBoxDisabled(false);
        }

        setIsTextBoxDisabled(false);
      })

      .catch((error) => {
        console.error("Error fetching Insurance names:", error);
      });
  };

  //Fetch CPT List

  const fetchCPTList = () => {
    if (!selectedCptValue) {
      // If searchText is empty, you may want to reset or clear any existing data
      setCptValueList([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }

    for (const rowIndex of cptAllCheckbox) {
      const item = tableDetails[rowIndex];

      item.CPT = selectedCPTCode;
    }

    var inputStruct = {
      cptCode: selectedCptValue,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + CommonAPIConstants.GetCPTList,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const cptData = parsedData.Data;

        const filteredCPTData = cptData.filter(
          (item) =>
            `${item.CPT_Code} ${item.CPTDescription}` !== selectedCptValue,
        );

        setCptValueList(filteredCPTData);
      })
      .catch((error) => {
        console.error("Error fetching CPT names:", error);
      });
  };

  useEffect(() => {
    // Fetch suggestions when the component mounts or when searchText changes
    fetchCPTList(selectedCptValue);
  }, [selectedCptValue]);

  const handleCPTList = (suggestion) => {
    setSelectedCptValue(`${suggestion.CPT_Code} ${suggestion.CPTDescription}`);
    setSelectedCPTCode(`${suggestion.CPT_Code}`);
    setCptValueList([]);
    setSelectedUnitValue(1);
    const billingFee = parseFloat(suggestion.Billing_Fee).toFixed(2);
    setSelectedUnitChargeValue(billingFee);
  };

  const handleCPTKeyDown = (e) => {
    if (e.key === "Backspace") {
      // Handle backspace key
      if (selectedCptValue === "" && cptValueList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setCptValueList([]);
      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchCPTList(selectedCptValue.slice(0, -1)); // Remove the last character from searchText
      }
    }
  };

  // Fetch Mod1 suggestion List

  const fetchMod1List = () => {
    if (!selectedMod1Value) {
      // If searchText is empty, you may want to reset or clear any existing data
      setMod1List([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }

    for (const rowIndex of mod1AllCheckbox) {
      const item = tableDetails[rowIndex];

      item.Mod1 = selectedMod1Data;
    }

    var inputStruct = {
      modName: selectedMod1Value,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + CommonAPIConstants.GetModList,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data;

        if (Array.isArray(modData)) {
          setMod1List(
            modData.map((item) => {
              if (item && typeof item === "object" && "Value" in item) {
                return {
                  val: item.Value.split(" | ")[0],
                };
              } else {
                console.error("Invalid item in modData:", item);
                return null;
              }
            }),
          );
        } else {
          setMod1List([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching Mod names:", error);
      });
  };

  useEffect(() => {
    fetchMod1List(selectedMod1Value);
  }, [selectedMod1Value]);

  const handleMod1List = (suggestion) => {
    const concatenatedValue = `${suggestion.val}-${suggestion.val}`;

    setSelectedMod1Value(concatenatedValue);
    setSelectedMod1Data(suggestion.val);
  };

  const handleMod1ListKeyDown = (e) => {
    if (e.key === "Backspace") {
      //Handle backspace key
      if (selectedMod1Value === "" && modDataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setMod1List([]);
      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchModList(selectedMod1Value.slice(0, -1)); //Remove the last character from searchText
      }
    }
  };

  //Fetch Mod2 suggestions List

  const fetchMod2Data = () => {
    if (!selectedMod2ListVal) {
      // If searchText is empty, you may want to reset or clear any existing data
      setMod2List([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }

    for (const rowIndex of mod2AllCheckbox) {
      const item = tableDetails[rowIndex];

      item.Mod2 = selectedMod2Data;
    }

    var inputStruct = {
      modName: selectedMod2ListVal,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + CommonAPIConstants.GetModList,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data;

        if (Array.isArray(modData)) {
          setMod2List(
            modData.map((item) => {
              if (item && typeof item === "object" && "Value" in item) {
                return {
                  val: item.Value.split(" | ")[0],
                };
              } else {
                console.error("Invalid item in modData:", item);
                return null;
              }
            }),
          );
        } else {
          setMod2List([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching Mod names:", error);
      });
  };

  useEffect(() => {
    fetchMod2Data(selectedMod2ListVal);
  }, [selectedMod2ListVal]);

  const handleMod2Data = (suggestion) => {
    const concatenatedValue = `${suggestion.val}-${suggestion.val}`;

    setSelectedMod2ListVal(concatenatedValue);

    setSelectedMod2Data(suggestion.val);
  };

  const handleMod2KeyDown = (e) => {
    if (e.key === "Backspace") {
      //Handle backspace key
      if (selectedMod2ListVal === "" && mod2List.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setMod2List([]);
      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchMod2Data(selectedMod2ListVal.slice(0, -1)); //Remove the last character from searchText
      }
    }
  };

  //Fetch Mod3 Suggestions List

  const fetchMod3Data = () => {
    if (!selectedMod3ListVal) {
      // If searchText is empty, you may want to reset or clear any existing data
      setMod3List([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }

    for (const rowIndex of mod3AllCheckbox) {
      const item = tableDetails[rowIndex];

      item.Mod3 = selectedMod3Data;
    }

    var inputStruct = {
      modName: selectedMod3ListVal,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + CommonAPIConstants.GetModList,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data;

        if (Array.isArray(modData)) {
          setMod3List(
            modData.map((item) => {
              if (item && typeof item === "object" && "Value" in item) {
                return {
                  val: item.Value.split(" | ")[0],
                };
              } else {
                console.error("Invalid item in modData:", item);
                return null;
              }
            }),
          );
        } else {
          setMod3List([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching Mod names:", error);
      });
  };

  useEffect(() => {
    fetchMod3Data(selectedMod3ListVal);
  }, [selectedMod3ListVal]);

  const handleMod3Data = (suggestion) => {
    const concatenatedValue = `${suggestion.val}-${suggestion.val}`;

    setSelectedMod3ListVal(concatenatedValue);

    setSelectedMod3Data(suggestion.val);
  };

  const handleMod3KeyDown = (e) => {
    if (e.key === "Backspace") {
      //Handle backspace key
      if (selectedMod3ListVal === "" && mod3List.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setMod3List([]);
      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchMod3Data(selectedMod3ListVal.slice(0, -1)); //Remove the last character from searchText
      }
    }
  };

  // Fetch ICD1 Suggestion List

  const fetchDiag1DataList = () => {
    if (!selectedDiag1List) {
      setDiag1List([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }

    for (const rowIndex of diag1AllCheckbox) {
      const item = tableDetails[rowIndex];

      item.ICDCode = selectedDiag1ID;
    }

    var inputStruct = {
      icdName: selectedDiag1List,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + CommonAPIConstants.GetIcdList,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const diagData = parsedData.Data;

        setDiag1List(diagData);
      })
      .catch((error) => {
        console.error("Error fetching ICD names:", error);
      });
  };

  useEffect(() => {
    fetchDiag1DataList(selectedDiag1List);
  }, [selectedDiag1List]);

  const handleDiag1DataList = (suggestion) => {
    setSelectedDiag1List(suggestion.Value);
    const diagID = suggestion.Value.split(" ")[0].trim();

    setSelectedDiag1ID(diagID);
  };

  const handleDiag1DataKeyDown = (e) => {
    if (e.key === "Backspace") {
      //Handle backspace key
      if (selectedDiag1List === "" && diag1List.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag1List([]);
      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag1DataList(selectedDiag1List.slice(0, -1)); //Remove the last character from searchText
      }
    }
  };

  //Fetch ICD2 Suggestion List

  const fetchDiag2DataList = () => {
    if (!selectedDiag2List) {
      setDiag2List([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }

    for (const rowIndex of diag2AllCheckbox) {
      const item = tableDetails[rowIndex];

      item.ICDCode2 = selectedDiag1ID;
    }

    var inputStruct = {
      icdName: selectedDiag2List,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + CommonAPIConstants.GetIcdList,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const diagData = parsedData.Data;

        setDiag2List(diagData);
      })
      .catch((error) => {
        console.error("Error fetching ICD names:", error);
      });
  };

  useEffect(() => {
    fetchDiag2DataList(selectedDiag2List);
  }, [selectedDiag2List]);

  const handleDiag2DataList = (suggestion) => {
    setSelectedDiag2List(suggestion.Value);
    const diagID = suggestion.Value.split(" ")[0].trim();

    setSelectedDiag1ID(diagID);
  };

  const handleDiag2DataKeyDown = (e) => {
    if (e.key === "Backspace") {
      //Handle backspace key
      if (selectedDiag2List === "" && diag2List.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag2List([]);
      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag2DataList(selectedDiag2List.slice(0, -1)); //Remove the last character from searchText
      }
    }
  };

  //Fetch ICD3 Suggestion List

  const fetchDiag3DataList = () => {
    if (!selectedDiag3List) {
      setDiag3List([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }

    for (const rowIndex of diag3AllCheckbox) {
      const item = tableDetails[rowIndex];

      item.ICDCode3 = selectedDiag1ID;
    }

    var inputStruct = {
      icdName: selectedDiag3List,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + CommonAPIConstants.GetIcdList,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const diagData = parsedData.Data;

        setDiag3List(diagData);
      })
      .catch((error) => {
        console.error("Error fetching ICD names:", error);
      });
  };

  useEffect(() => {
    fetchDiag3DataList(selectedDiag3List);
  }, [selectedDiag3List]);

  const handleDiag3DataList = (suggestion) => {
    setSelectedDiag3List(suggestion.Value);
    const diagID = suggestion.Value.split(" ")[0].trim();

    setSelectedDiag1ID(diagID);
  };

  const handleDiag3DataKeyDown = (e) => {
    if (e.key === "Backspace") {
      //Handle backspace key
      if (selectedDiag3List === "" && diag3List.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag3List([]);
      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag3DataList(selectedDiag3List.slice(0, -1)); //Remove the last character from searchText
      }
    }
  };

  //Fetch ICD4 Suggestion List

  const fetchDiag4DataList = () => {
    if (!selectedDiag4List) {
      setDiag4List([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }

    for (const rowIndex of diag4AllCheckbox) {
      const item = tableDetails[rowIndex];

      item.ICDCode4 = selectedDiag1ID;
    }

    var inputStruct = {
      icdName: selectedDiag4List,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + CommonAPIConstants.GetIcdList,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const diagData = parsedData.Data;

        setDiag4List(diagData);
      })
      .catch((error) => {
        console.error("Error fetching ICD names:", error);
      });
  };

  useEffect(() => {
    fetchDiag4DataList(selectedDiag4List);
  }, [selectedDiag4List]);

  const handleDiag4DataList = (suggestion) => {
    setSelectedDiag4List(suggestion.Value);
    const diagID = suggestion.Value.split(" ")[0].trim();

    setSelectedDiag1ID(diagID);
  };

  const handleDiag4DataKeyDown = (e) => {
    if (e.key === "Backspace") {
      //Handle backspace key
      if (selectedDiag4List === "" && diag4List.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag4List([]);
      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag4DataList(selectedDiag4List.slice(0, -1)); //Remove the last character from searchText
      }
    }
  };

  // Fetch Providers List for Dialogbox

  const fetchSearchProvidersList = () => {
    if (!selectedProviderText) {
      setProviderDataList([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }

    var inputStruct = {
      sProviderName: selectedProviderText,
      sPracticeID: userPracticeID,
      LoggedInUserDetails: userData,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + IntelliBillConstants.GetIntelliProvidersNames,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const providersData = parsedData.Data;

        if (Array.isArray(providersData)) {
          // Correct the structure of filteredProviders
          const filteredProviders = providersData
            .filter((item) =>
              item.toLowerCase().includes(selectedProviderText.toLowerCase()),
            )
            .map((item) => ({
              label: item.split("$")[0].split("|")[1].trim(),
              id: item.split("$")[1].trim(),
            }))
            .filter((item) => item.label !== selectedProviderSuggestion.label);

          setProviderDataList(filteredProviders);
        } else {
          setProviderDataList([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching provider names:", error);
      });
  };

  const isProviderMounted = useRef(true);

  useEffect(() => {
    if (isProviderMounted.current) {
      isProviderMounted.current = false;
    } else {
      fetchSearchProvidersList(selectedProviderText);
    }
  }, [selectedProviderText]);

  const handleProviderSuggestionList = (suggestion) => {
    setSelectedProviderText(`${suggestion.label}`);
    setSelectedProviderSuggestion(`${suggestion.id}`);
    setProviderDataList([]);
    setSelectedPatientID(selectedPatientID);
  };

  const handleProviderListKeyDown = (e) => {
    if (e.key === "Backspace") {
      // Handle backspace key
      if (selectedProviderText === "" && providerDataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setProviderDataList([]);
      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchSearchProvidersList(selectedProviderText.slice(0, -1)); // Remove the last character from searchText
      }
    }
  };

  //Fetch CPT List

  const fetchSearchCPTList = () => {
    if (!selectedCPTList) {
      // If searchText is empty, you may want to reset or clear any existing data
      setCptDataList([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }

    var inputStruct = {
      cptCode: selectedCPTList,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + CommonAPIConstants.GetCPTList,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const cptData = parsedData.Data;

        const filteredCPTData = cptData.filter(
          (item) =>
            `${item.CPT_Code} ${item.CPTDescription}` !== selectedCPTList,
        );

        setCptDataList(filteredCPTData);
      })
      .catch((error) => {
        console.error("Error fetching CPT names:", error);
      });
  };

  useEffect(() => {
    // Fetch suggestions when the component mounts or when searchText changes
    fetchSearchCPTList(selectedCPTList);
  }, [selectedCPTList]);

  const handleSearchCPTList = (suggestion) => {
    setSelectedCPTList(`${suggestion.CPT_Code} ${suggestion.CPTDescription}`);
    setSelectedCPTCode(`${suggestion.CPT_Code}`);
    setCptDataList([]);
    setSelectedUnitValue(1);
    const billingFee = parseFloat(suggestion.Billing_Fee).toFixed(2);
    setSelectedUnitChargeValue(billingFee);
  };

  const handleCPTListKeyDown = (e) => {
    if (e.key === "Backspace") {
      // Handle backspace key
      if (selectedCPTList === "" && cptDataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setCptDataList([]);
      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchSearchCPTList(selectedCPTList.slice(0, -1)); // Remove the last character from searchText
      }
    }
  };

  //Fetch Mod1 List

  const fetchModList = () => {
    if (!selectedModList) {
      // If searchText is empty, you may want to reset or clear any existing data
      setModDataList([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }

    var inputStruct = {
      modName: selectedModList,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + CommonAPIConstants.GetModList,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data;

        if (Array.isArray(modData)) {
          setModDataList(
            modData.map((item) => {
              if (item && typeof item === "object" && "Value" in item) {
                return {
                  val: item.Value.split(" | ")[0],
                };
              } else {
                console.error("Invalid item in modData:", item);
                return null;
              }
            }),
          );
        } else {
          setModDataList([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching Mod names:", error);
      });
  };

  useEffect(() => {
    fetchModList(selectedModList);
  }, [selectedModList]);

  const handleModList = (suggestion) => {
    setSelectedModList(suggestion);
  };

  const handleModListKeyDown = (e) => {
    if (e.key === "Backspace") {
      //Handle backspace key
      if (selectedModList === "" && modDataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setModDataList([]);
      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchModList(selectedModList.slice(0, -1)); //Remove the last character from searchText
      }
    }
  };

  //Fetch Mod2 SuggestionList

  const fetchMod2List = () => {
    if (!selectedMod2Value) {
      // If searchText is empty, you may want to reset or clear any existing data
      setMod2DataList([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }

    var inputStruct = {
      modName: selectedMod2Value,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + CommonAPIConstants.GetModList,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data;

        if (Array.isArray(modData)) {
          setMod2DataList(
            modData.map((item) => {
              if (item && typeof item === "object" && "Value" in item) {
                return {
                  val: item.Value.split(" | ")[0],
                };
              } else {
                console.error("Invalid item in modData:", item);
                return null;
              }
            }),
          );
        } else {
          setMod2DataList([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching Mod names:", error);
      });
  };

  useEffect(() => {
    fetchMod2List(selectedMod2Value);
  }, [selectedMod2Value]);

  const handleMod2List = (suggestion) => {
    setSelectedMod2Value(suggestion);
    //setMod2DataList([]);
  };

  const handleMod2ListKeyDown = (e) => {
    if (e.key === "Backspace") {
      //Handle backspace key
      if (selectedMod2Value === "" && mod2DataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setMod2DataList([]);
      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchMod2List(selectedMod2Value.slice(0, -1)); //Remove the last character from searchText
      }
    }
  };

  //Fetch Mod3 SuggestionList

  const fetchMod3List = () => {
    if (!selectedMod3Value) {
      // If searchText is empty, you may want to reset or clear any existing data
      setMod3DataList([]);
      setIsSuggestionBoxDisabled(true); // Disable suggestion box if needed
      return; // Skip API call
    }

    var inputStruct = {
      modName: selectedMod3Value,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + CommonAPIConstants.GetModList,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data;

        if (Array.isArray(modData)) {
          setMod3DataList(
            modData.map((item) => {
              if (item && typeof item === "object" && "Value" in item) {
                return {
                  val: item.Value.split(" | ")[0],
                };
              } else {
                console.error("Invalid item in modData:", item);
                return null;
              }
            }),
          );
        } else {
          setMod3DataList([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching Mod names:", error);
      });
  };

  useEffect(() => {
    fetchMod3List(selectedMod3Value);
  }, [selectedMod3Value]);

  const handleMod3List = (suggestion) => {
    setSelectedMod3Value(suggestion);
    // setMod3DataList([]);
  };

  const handleMod3ListKeyDown = (e) => {
    if (e.key === "Backspace") {
      //Handle backspace key
      if (selectedMod3Value === "" && mod3DataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setMod3DataList([]);
      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchMod3List(selectedMod3Value.slice(0, -1)); //Remove the last character from searchText
      }
    }
  };

  //Fetch ICD1 Suggestion List

  const fetchDiag1List = () => {
    if (!selectedDiag1Value) {
      setDiag1DataList([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }

    var inputStruct = {
      icdName: selectedDiag1Value,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + CommonAPIConstants.GetIcdList,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const diagData = parsedData.Data;

        setDiag1DataList(diagData);
      })
      .catch((error) => {
        console.error("Error fetching ICD names:", error);
      });
  };

  useEffect(() => {
    fetchDiag1List(selectedDiag1Value);
  }, [selectedDiag1Value]);

  const handleDiag1List = (suggestion) => {
    setSelectedDiag1Value(suggestion.Value);
    const diagID = suggestion.Value.split(" ")[0].trim();

    setSelectedDiag1ID(diagID);
  };

  const handleDiag1ListKeyDown = (e) => {
    if (e.key === "Backspace") {
      //Handle backspace key
      if (selectedDiag1Value === "" && diag1DataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag1DataList([]);
      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag1List(selectedDiag1Value.slice(0, -1)); //Remove the last character from searchText
      }
    }
  };

  //Fetch ICD2 Suggestion List

  const fetchDiag2List = () => {
    if (!selectedDiag2Value) {
      setDiag2DataList([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }

    var inputStruct = {
      icdName: selectedDiag2Value,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + CommonAPIConstants.GetIcdList,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data;

        setDiag2DataList(modData);
      })
      .catch((error) => {
        console.error("Error fetching ICD names:", error);
      });
  };

  useEffect(() => {
    fetchDiag2List(selectedDiag2Value);
  }, [selectedDiag2Value]);

  const handleDiag2List = (suggestion) => {
    setSelectedDiag2Value(suggestion.Value);
    const diagID = suggestion.Value.split(" ")[0].trim();

    setSelectedDiag2ID(diagID);
  };

  const handleDiag2ListKeyDown = (e) => {
    if (e.key === "Backspace") {
      //Handle backspace key
      if (selectedDiag2Value === "" && diag2DataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag2DataList([]);
      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag2List(selectedDiag2Value.slice(0, -1)); //Remove the last character from searchText
      }
    }
  };

  //Fetch ICD3 Suggestion List
  const fetchDiag3List = () => {
    if (!selectedDiag3Value) {
      setDiag3DataList([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }

    var inputStruct = {
      icdName: selectedDiag3Value,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + CommonAPIConstants.GetIcdList,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data;

        setDiag3DataList(modData);
      })
      .catch((error) => {
        console.error("Error fetching ICD names:", error);
      });
  };

  useEffect(() => {
    fetchDiag3List(selectedDiag3Value);
  }, [selectedDiag3Value]);

  const handleDiag3List = (suggestion) => {
    setSelectedDiag3Value(suggestion.Value);
    const diagID = suggestion.Value.split(" ")[0].trim();

    setSelectedDiag3ID(diagID);
  };

  const handleDiag3ListKeyDown = (e) => {
    if (e.key === "Backspace") {
      //Handle backspace key
      if (selectedDiag3Value === "" && diag3DataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag3DataList([]);
      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag3List(selectedDiag3Value.slice(0, -1)); //Remove the last character from searchText
      }
    }
  };

  //Fetch ICD4 Suggestion List

  const fetchDiag4List = () => {
    if (!selectedDiag4Value) {
      setDiag4DataList([]);
      setIsSuggestionBoxDisabled(true);
      return;
    }

    var inputStruct = {
      icdName: selectedDiag4Value,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + CommonAPIConstants.GetIcdList,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const modData = parsedData.Data;

        setDiag4DataList(modData);
      })
      .catch((error) => {
        console.error("Error fetching ICD names:", error);
      });
  };

  useEffect(() => {
    fetchDiag4List(selectedDiag4Value);
  }, [selectedDiag4Value]);

  const handleDiag4List = (suggestion) => {
    setSelectedDiag4Value(suggestion.Value);
    const diagID = suggestion.Value.split(" ")[0].trim();

    setSelectedDiag4ID(diagID);
  };

  const handleDiag4ListKeyDown = (e) => {
    if (e.key === "Backspace") {
      //Handle backspace key
      if (selectedDiag4Value === "" && diag4DataList.length > 0) {
        // If input is empty and there are suggestions, remove the entire list
        setDiag4DataList([]);
      } else {
        // If input is not empty, dynamically filter suggestions based on the current input
        fetchDiag4List(selectedDiag4Value.slice(0, -1)); //Remove the last character from searchText
      }
    }
  };

  const handleSelectBillingNPI = (event) => {
    const selectedValue = event.target.value;
    setSelectedBillingNPI(selectedValue);
  };

  const filteredProviders = practiceProvider1?.filter(
    (provider) => provider.Supervisor === "1" || provider.Supervisor === "3",
  );

  const handleSelectFilterProviders = (event) => {
    const selectedValue = event.target.value;
    setSelectedFilterProvider(selectedValue);
  };

  const [selectedProvider, setSelectedProvider] = useState("");
  const [tdata, setTdata] = useState("");

  // Function to handle checkbox change
  const handleCheckboxChange = (e) => {
    const value = e.target.checked ? 1 : 0; // Set 1 if checked, 0 if unchecked
    setIsChecked(value);
  };

  useEffect(() => {
    setSelectedCheckedRadioButton("0");
    setSelectedStatusRadioButton("0");
  }, []);

  const handleRadioChange = (e) => {
    setSelectedCheckedRadioButton(e.target.value);
    const selectedValue = e.target.value;
    setsCheckedInStatus(selectedValue);
  };

  useEffect(() => {
    handleTableDataClick();
  }, [selectedCheckedRadioButton]);

  const handleClaimStatusChange = (e) => {
    setSelectedStatusRadioButton(e.target.value);
    const selectedValue = e.target.value;
    setsClaimStatus(selectedValue);
  };

  useEffect(() => {
    handleTableDataClick();
  }, [selectedStatusRadioButton]);

  const handleSuggestionChange = (e) => {
    setSelectedSearchFilter(e.target.value);
    const selectedValue = e.target.value;
    setsFilterType(selectedValue);
  };

  const processTableData = () => {
    tableDetails.forEach((item) => {
      setRowsValidation(item.DataValidationMessage);
    });
  };

  //All clearingHouse Data

  const handleAllClearingHouse = () => {
    var inputStruct = {
      sPracticeID: userPracticeID,
    };

    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);

    const response = fetch(
      APIConstants.BASE_URL + CommonAPIConstants.GetAllclearingHouse,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },

        body: myInputData,
      },
    )
      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const allClearingHouseData = parsedData.Data;

        setSelectClearingHouse(allClearingHouseData);
      })
      .catch((error) => {
        console.error("Error fetching All clearing house:", error);
      });
  };

  useEffect(() => {
    handleAllClearingHouse();
  }, []);

  //Bind the Intelli Bill table details

  const handleTableDataClick = (DataValidationMessage) => {
    // console.log("Dropdown Data:", selectAllDropDown);
    setLoading(true);

    setSelectedRows([]);
    var MissingData = DataValidationMessage;

    if (MissingData != "") {
    }

    var inputStruct = {
      PracticeID: userPracticeID + "",
      FromDate: startDate,
      LocationID: selectLocationID,
      bIsFilterEmptyCPT: 1,
      ToDate: endDate,
      PatientID: sPatID + "",
      FilterText: sFilterType === "CPT" ? searchText : sPatID + "",
      FilterType: sFilterType + "",
      sTempPatID: sPatID + "",
      Workableclaims: false,
      ErroClaimsfilter: false,
      CPT: searchText,
      IsMacro: "",
      ClaimStatus: sClaimStatus,
      IsCheckdin: Number(sCheckedInStatus),
      IsTransferred: false,
      IsClosedClaims: isClosedClaim,
    };

    var sJSONInput = JSON.stringify({ objClaims: inputStruct });
    // console.log(
    //   "input of" + IntelliBillConstants.GetIntelliTabledata,
    //   sJSONInput,
    // );
    const url = `${APIConstants.BASE_URL_BILLING}${IntelliBillConstants.GetIntelliTabledata}?sInputJSON=${sJSONInput}`;

    // console.log("URL: ", url);

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${sAuthToken}`,
      },
    })
      .then((response) => {
        if (response.status != 200) {
          console.log("response.status", response.status);
        } else return response.json();
      })
      .then((data) => {
        setTimeout(() => {
          setLoading(false);
          setTableDetails(data.objIntellibillData);
          setFilteredTableDetails(data.objIntellibillData);
        }, 100);

        console.log(
          "tableData of" + IntelliBillConstants.GetIntelliTabledata,
          data.objIntellibillData,
        );

        const tableInsData = data.objIntellibillPatIns;
        setTableInsDetails(tableInsData);
      })

      .catch((error) => {
        setError("API request failed");
        setLoading(false);
      });
  };

  const handleDataKeyDown = (e) => {
    if (e.key === "Enter") {
      handleTableDataClick("");
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleDataKeyDown);

    return () => {
      window.removeEventListener("keydown", handleDataKeyDown);
    };
  }, [startDate, endDate, sFilterType, searchText]);

  useEffect(() => {
    const filteredData = filteredTableDetails.filter((item) => {
      if (
        selectedCheckedRadioButton === "All" ||
        selectedCheckedRadioButton === "CheckedIn" ||
        selectedCheckedRadioButton === "Non-CheckedIn"
      ) {
        if (
          selectedStatusRadioButton === "All" ||
          (selectedStatusRadioButton === "Submitted" &&
            item.ClaimStatus === "Submitted") ||
          (selectedStatusRadioButton === "Non-Submitted" &&
            item.ClaimStatus !== "Submitted")
        ) {
          return true;
        }
      }
      return false;
    });

    setFilteredTableDetails(filteredData);
  }, [selectedCheckedRadioButton, selectedStatusRadioButton]);

  const filterLocationData = (data, location, searchText) => {
    return data.filter((item) => {
      if (location === "all") {
        return true;
      } else {
        const locationToCompare = item.LocationNickname;

        return (
          locationToCompare === location ||
          (location === "Test Practice" && locationToCompare === "TP1") ||
          (location === "OH Secondary Center" && locationToCompare === "Sec")
        );
      }
    });
  };

  const filterTableData = () => {
    const filteredData = tableDetails.filter((item) => {
      return item[selectedSearchFilter]
        .toLowerCase()
        .includes(searchText.toLowerCase());
    });

    // Set the filtered data to your state
    setTableDetails(filteredData);
  };

  const handleClearinghouseChange = (index, e) => {
    const selectedValue = e.target.value;
    setClearingHouse(selectedValue);

    const updatedRows = [...filteredTableDetails];
    updatedRows[index].ClearingHouse = selectedValue;

    // Set the updated state
    setFilteredTableDetails(updatedRows);
  };

  // useEffect(() => {

  //   console.log("ClearingHouse", ClearingHouse);
  // }, []);

  const handleClearingRowCheckboxChange = (index, item) => {
    if (selectClearingHouseRow.includes(index)) {
      setSelectClearingHouseRow(
        selectClearingHouseRow.filter((selectedRow) => selectedRow !== index),
      );
    } else {
      setSelectClearingHouseRow([...selectClearingHouseRow, index]);
    }
    setSelectAllClearingHouseRow(false);
  };

  const handleAllClearingHouseRow = () => {
    const allSelected = tableDetails.every((_, index) =>
      selectClearingHouseRow.includes(index),
    );

    if (allSelected && selectClearingHouseRow.length === tableDetails.length) {
      // Deselect all checkboxes

      setSelectAllClearingHouseRow(false);
      setSelectedRows([]);
      setSelectClearingHouseRow([]);
    } else {
      // Select all checkboxes
      setSelectClearingHouseRow(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );
      setSelectAllClearingHouseRow(true);
      setSelectedRows(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );
    }
  };

  // useEffect(() => {

  //   return () => setSelectedRows([]);
  // }, []);

  const handleRowCheckboxChange = (index, row) => {
    setSelectedRows((prevSelected) => {
      const exists = prevSelected.some((item) => item.index === index);

      if (exists) {
        return prevSelected.filter((item) => item.index !== index);
      }

      return [...prevSelected, { ...row, index }];
    });
  };

  const handleSelectAllChange = () => {
    // Rows that are allowed to be selected
    const selectableRows = tableDetails
      .map((row, index) => ({ ...row, index }))
      .filter(
        (item) =>
          item.isReadyforApproval !== 1 &&
          (item.Status === "" || item.Status === null),
      );

    const allSelected = selectableRows.every((row) =>
      selectedRows.some((selected) => selected.index === row.index),
    );

    if (allSelected) {
      setSelectedRows([]);
    } else {
      setSelectedRows(selectableRows);
    }
  };

  const handleCloseClaimAllChange = (isChecked) => {
    if (isChecked) {
      const filteredRows = tableDetails.filter(
        item => item.PrimaryIns === 281
      );

      const rowIds = filteredRows.map(item => item.CPTRowID);

      setcloseClaimChecbox(rowIds);
      setFilteredTableDetails(filteredRows);
    } else {
      setcloseClaimChecbox([]);
      setFilteredTableDetails(tableDetails);
    }

    setcloseAllClaimCheckbox(isChecked);
  };

  const handleCloseClaimCheckboxChange = (item) => {
    const rowId = item.CPTRowID;

    if (closeClaimChecbox.includes(rowId)) {
      setcloseClaimChecbox(closeClaimChecbox.filter((id) => id !== rowId));
    } else {
      setcloseClaimChecbox([...closeClaimChecbox, rowId]);
    }
    setSelectAllRowsChecked(false);
  };

  const handleSelectLocationAllChange = () => {
    const allSelected = tableDetails.every((_, index) =>
      selectedLocationRows.includes(index),
    );

    if (allSelected) {
      // Deselect all checkboxes
      setSelectedLocationRows([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setSelectedLocationRows(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );

      setSelectedRows(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );
    }
  };

  const handleLocRowCheckboxChange = (index) => {
    setSelectedLocationRows((prevSelectedRows) => {
      if (prevSelectedRows.includes(index)) {
        // If already selected, remove from the list

        return prevSelectedRows.filter((selectedRow) => selectedRow !== index);
      } else {
        // If not selected, add to the list
        return [...prevSelectedRows, index];
      }
    });
  };

  // change the header dropdown for service

  // useEffect(() => {
  //   // updateValueField();
  // }, [selectedLocationRows, selectedValueLocRows, selectedServiceLocation]);

  const handleUnitChargeAllChange = () => {
    const allRowIds = tableDetails.map(item => item.CPTRowID);
    const allSelected = allRowIds.every(id =>
      UnitChargeRows.includes(id)
    );

    if (allSelected) {
      setUnitChargeRows([]);
      setSelectedRows([]);
    } else {
      setUnitChargeRows(allRowIds);
      setSelectedRows(allRowIds);
    }
  }

  const handleUnitChargeRowCheckbox = (rowId) => {
    if (UnitChargeRows.includes(rowId)) {
      setUnitChargeRows(prev =>
        prev.filter(id => id !== rowId)
      );
    } else {
      setUnitChargeRows(prev => [...prev, rowId]);
    }
  };

  const handleSelectUnitAllChange = () => {
    const allRowIds = tableDetails.map(item => item.CPTRowID);
    const allSelected = allRowIds.every(id =>
      unitCheckbox.includes(id)
    );

    if (allSelected) {
      setUnitCheckbox([]);
      setSelectedRows([]);
    } else {
      setUnitCheckbox(allRowIds);
      setSelectedRows(allRowIds);
    }
  };

  const handleUnitRowCheckboxChange = (rowId) => {
    if (unitCheckbox.includes(rowId)) {
      setUnitCheckbox(prev =>
        prev.filter(id => id !== rowId)
      );
    } else {
      setUnitCheckbox(prev => [...prev, rowId]);
    }
  };

  const handleSelectDiag4AllChange = () => {
    const allSelected = tableDetails.every((_, index) =>
      diag4AllCheckbox.includes(index),
    );

    if (allSelected) {
      // Deselect all checkboxes
      setDiag4AllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setDiag4AllCheckbox(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );

      setSelectedRows(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );
    }
  };

  const handleDiag4RowCheckboxChange = (index) => {
    if (diag4AllCheckbox.includes(index)) {
      setDiag4AllCheckbox(
        diag4AllCheckbox.filter((selectedRow) => selectedRow !== index),
      );

      setSelectedRows([]);
    } else {
      setDiag4AllCheckbox([...diag4AllCheckbox, index]);
      setSelectedRows([...selectedRows, index]);
    }
  };

  const handleSelectDiag3AllChange = () => {
    const allSelected = tableDetails.every((_, index) =>
      diag3AllCheckbox.includes(index),
    );

    if (allSelected) {
      // Deselect all checkboxes
      setDiag3AllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setDiag3AllCheckbox(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );

      setSelectedRows(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );
    }
  };

  const handleDiag3RowCheckboxChange = (index) => {
    if (diag3AllCheckbox.includes(index)) {
      setDiag3AllCheckbox(
        diag3AllCheckbox.filter((selectedRow) => selectedRow !== index),
      );

      setSelectedRows([]);
    } else {
      setDiag3AllCheckbox([...diag3AllCheckbox, index]);
      setSelectedRows([...selectedRows, index]);
    }
  };

  const handleSelectDiag2AllChange = () => {
    const allSelected = tableDetails.every((_, index) =>
      diag2AllCheckbox.includes(index),
    );

    if (allSelected) {
      // Deselect all checkboxes
      setDiag2AllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setDiag2AllCheckbox(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );

      setSelectedRows(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );
    }
  };

  const handleDiag2RowCheckboxChange = (index) => {
    if (diag2AllCheckbox.includes(index)) {
      setDiag2AllCheckbox(
        diag2AllCheckbox.filter((selectedRow) => selectedRow !== index),
      );
      setSelectedRows([]);
    } else {
      setDiag2AllCheckbox([...diag2AllCheckbox, index]);
      setSelectedRows([...selectedRows, index]);
    }
  };

  const handleSelectDiag1AllChange = () => {
    const allSelected = tableDetails.every((_, index) =>
      diag1AllCheckbox.includes(index),
    );

    if (allSelected) {
      // Deselect all checkboxes
      setDiag1AllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setDiag1AllCheckbox(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );

      setSelectedRows(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );
    }
  };

  const handleDiag1RowCheckboxChange = (index) => {
    if (diag1AllCheckbox.includes(index)) {
      setDiag1AllCheckbox(
        diag1AllCheckbox.filter((selectedRow) => selectedRow !== index),
      );
      setSelectedRows([]);
    } else {
      setDiag1AllCheckbox([...diag1AllCheckbox, index]);
      setSelectedRows([...selectedRows, index]);
    }
  };

  const handleSelectMod3AllChange = () => {
    const allSelected = tableDetails.every((_, index) =>
      mod3AllCheckbox.includes(index),
    );

    if (allSelected) {
      // Deselect all checkboxes
      setMod3AllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setMod3AllCheckbox(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );

      setSelectedRows(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );
    }
  };

  const handleMod3RowCheckboxChange = (index) => {
    if (mod3AllCheckbox.includes(index)) {
      setMod3AllCheckbox(
        mod3AllCheckbox.filter((selectedRow) => selectedRow !== index),
      );

      setSelectedRows([]);
    } else {
      setMod3AllCheckbox([...mod3AllCheckbox, index]);
      setSelectedRows([...selectedRows, index]);
    }
  };

  const handleSelectMod2AllChange = () => {
    const allSelected = tableDetails.every((_, index) =>
      mod2AllCheckbox.includes(index),
    );

    if (allSelected) {
      // Deselect all checkboxes
      setMod2AllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setMod2AllCheckbox(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );

      setSelectedRows(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );
    }
  };

  const handleMod2RowCheckboxChange = (index) => {
    if (mod2AllCheckbox.includes(index)) {
      setMod2AllCheckbox(
        mod2AllCheckbox.filter((selectedRow) => selectedRow !== index),
      );
      setSelectedRows([]);
    } else {
      setMod2AllCheckbox([...mod2AllCheckbox, index]);
      setSelectedRows([...selectedRows, index]);
    }
  };

  const handleSelectMod1AllChange = () => {
    const allSelected = tableDetails.every((_, index) =>
      mod1AllCheckbox.includes(index),
    );

    if (allSelected) {
      // Deselect all checkboxes
      setMod1AllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setMod1AllCheckbox(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );

      setSelectedRows(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );
    }
  };

  const handleMod1RowCheckboxChange = (index) => {
    if (mod1AllCheckbox.includes(index)) {
      setMod1AllCheckbox(
        mod1AllCheckbox.filter((selectedRow) => selectedRow !== index),
      );

      setSelectedRows([]);
    } else {
      setMod1AllCheckbox([...mod1AllCheckbox, index]);
      setSelectedRows([...selectedRows, index]);
    }
  };

  const handleSelectCPTAllChange = () => {
    const allSelected = tableDetails.every((_, index) =>
      cptAllCheckbox.includes(index),
    );

    if (allSelected) {
      // Deselect all checkboxes
      setCptAllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setCptAllCheckbox(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );

      setSelectedRows(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );
    }
  };

  const handleCPTRowCheckboxChange = (index) => {
    if (cptAllCheckbox.includes(index)) {
      setCptAllCheckbox(
        cptAllCheckbox.filter((selectedRow) => selectedRow !== index),
      );

      setSelectedRows([]);
    } else {
      setCptAllCheckbox([...cptAllCheckbox, index]);
      setSelectedRows([...selectedRows, index]);
    }
  };

  const handleSelectProviderAllChange = () => {
    const allSelected = tableDetails.every((_, index) =>
      providerAllCheckbox.includes(index),
    );

    if (allSelected) {
      // Deselect all checkboxes
      setProviderAllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setProviderAllCheckbox(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );

      setSelectedRows(
        Array.from({ length: tableDetails.length }, (_, index) => index),
      );
    }
  };

  const handleProviderRowCheckboxChange = (index) => {
    if (providerAllCheckbox.includes(index)) {
      setProviderAllCheckbox(
        providerAllCheckbox.filter((selectedRow) => selectedRow !== index),
      );
      setSelectedRows([]);
    } else {
      setProviderAllCheckbox([...providerAllCheckbox, index]);
      setSelectedRows([...selectedRows, index]);
    }
  };

  const handleSelectInsuranceAllChange = () => {
    const allRowIds = tableDetails.map((item) => item.CPTRowID);
    const allSelected = allRowIds.every((id) =>
      insuranceAllCheckbox.includes(id),
    );

    if (allSelected) {
      // Deselect all checkboxes
      setInsuranceAllCheckbox([]);
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setInsuranceAllCheckbox(tableDetails.map((item) => item.CPTRowID));

      setSelectedRows(tableDetails.map((item) => item.CPTRowID));
    }
  };

  const handleInsuranceRowCheckbox = (item) => {
    const rowId = item.CPTRowID;

    setClaimID(item.ClaimId);

    if (insuranceAllCheckbox.includes(rowId)) {
      setInsuranceAllCheckbox((prev) => prev.filter((id) => id !== rowId));
      setSelectedInsRows((prev) => prev.filter((id) => id !== rowId));
    } else {
      setInsuranceAllCheckbox((prev) => [...prev, rowId]);
      setSelectedInsRows((prev) => [...prev, rowId]);
    }
  };

  // useEffect(() => {

  // }, [insuranceAllCheckbox]);

  // const handleOpenModal = () => {
  //   if (selectedRows.length === 0) {
  //     // Show error modal if no rows are selected

  //     setShowSelectErrorModal(true);
  //   } else {
  //     // Show confirm save modal if rows are selected

  //     setShowConfirmSaveModal(true);
  //   }
  // };

  const handleOpenApprovalModal = () => {
    if (selectedRows.length === 0) {
      setShowSelectErrorModal(true);
      return;
    }

    let validationError = "";

    if (!selectedBillingNPI || selectedBillingNPI <= 0) {
      validationError += "Please select service location NPI.\n";
    }
    if (!selectedCMS33a || selectedCMS33a <= 0) {
      validationError += "Please enter billing provider NPI.\n";
    }
    if (!selectedCMS33b || selectedCMS33b <= 0) {
      validationError += "Please select billing provider taxonomy code.\n";
    }
    if (!selectedPracticeProvider || selectedPracticeProvider <= 0) {
      validationError += "Please select scheduling Provider\n";
    }

    if (validationError) {
      setErrorMessage(validationError);
      return;
    }

    // All validations passed
    setShowApprovalSaveModal(true);
  };

  const handleCloseModals = () => {
    // Close all modals
    setShowSelectErrorModal(false);
    setShowConfirmSaveModal(false);
    setShowSuccessModal(false);
    setShowDeleteModal(false);
    setShowApprovalSaveModal(false);
    setCloseClaimsModal(false);
    setShowFaxModal(false);
    setShowICDErrorModal(false);
    setICDConfirmSaveModal(false);
    setIsEPINVerifiedModal(false);
    setErrorMessage(false);
    setShowCopaySuccessModal(false);
  };

  const handleOpenDeleteModal = () => {
    if (selectedRows.length === 0) {
      setShowSelectErrorModal(true);
    } else {
      setShowDeleteModal(true);
    }
  };

  //Updated claims functionality

  const handleUpdatedClaims = async (e, isSaveForApproval) => {
    e.preventDefault();

    try {
      if (!selectedRows.length) {
        setShowSelectErrorModal(true);
        return;
      }

      // If selectedRows stores indexes, map them to tableDetails
      const selectedDataArray = selectedRows.map((row) => {
        const item = typeof row === "number" ? tableDetails[row] : row;

        return {
          PatientID: item?.PatientId ?? "",
          Procedure: item?.CPT ?? "",
          ICDCode1: item?.ICDCode ?? "",
          ICDCode2: item?.ICDCode2 ?? "",
          ICDCode3: item?.ICDCode3 ?? "",
          ICDCode4: item?.ICDCode4 ?? "",
          Unit: item?.Unit ?? "",
          UnitCharge: item?.Unitcharge ?? "",
          TotalCharge: item?.TotalCharge ?? "",
          ClaimID: item?.ClaimId ?? "",
          CPTRowID: item?.CPTRowID ?? "",
          Mod1: item?.Mod1 ?? "",
          Mod2: item?.Mod2 ?? "",
          Mod3: item?.Mod3 ?? "",
          RenderingProvider: searchProvidersText || item?.providerid || "",
          PolicyNumber: item?.PolicyNumber ?? "",
          PrimaryIns: item?.PrimaryIns ?? "",
          Claim32a: selectedBillingNPI ?? "",
          Claim33a: selectedCMS33a ?? "",
          Claim33b: selectedCMS33b ?? "",
          PlaceofService: selectedLocation ?? "",
          DOS: item?.DOS ?? "",
          SupervisingProvider: selectedFilterProvider ?? "",
          SchedulingProvider: selectedPracticeProvider ?? "",
          ServiceLocationCode: item?.ServiceLocationCode ?? "",
          Box17Indicator: selectedProvidersCategory ?? "",
          ClearingHouse: ClearingHouse ?? "",
        };
      });

      // ✅ Proper payload (no double stringify)
      const inputStruct = {
        SelectedClaims: selectedDataArray,
        IsSaveforApproval: isSaveForApproval,
        PracticeID: userData.practiceID,
        IsFromDenial: 0,
        UserID: userData.userID,
      };

      const myInput = JSON.stringify(JSON.stringify({ objClaim: inputStruct }));

      const response = await fetch(
        `${APIConstants.BASE_URL_BILLING}${CommonAPIConstants.SaveForApproval}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${sAuthToken}`,
          },
          body: myInput,
        },
      );

      if (!response.ok) {
        throw new Error(`API error: ${response.status}`);
      }

      const responseData = await response.json();

      // ✅ UI state updates
      setShowSelectErrorModal(false);
      setShowConfirmSaveModal(false);
      setShowApprovalSaveModal(false);
      setSavedRowCount(selectedRows.length);
      setShowSuccessModal(responseData);
      setSelectedRows([]);
      handleTableDataClick();

    } catch (error) {
      console.error("Error saving claims:", error);
      setShowSelectErrorModal(true);
    }
  };

  //Checkeligibility functionality

  const handleDelete = () => {
    resetDialogValues();

    const updatedRows = tableDetails.filter(
      (row, index) => !selectedRows.includes(index),
    );

    setTableDetails(updatedRows);

    setShowDeleteModal(false);
    setDeleteSuccessModal(true);
    setSelectedRows([]);
    setDeleteRowCount(selectedRows.length);
  };

  const DeleteclaimICDDetails = async () => {
    const JsonDataArr = [];

    [
      diag1AllCheckbox,
      diag2AllCheckbox,
      diag3AllCheckbox,
      diag4AllCheckbox,
    ].forEach((checkboxArray, index) => {
      checkboxArray.forEach((rowIndex) => {
        const item = tableDetails[rowIndex];
        const clmnName =
          index === 0
            ? "Diag1"
            : index === 1
              ? "Diag2"
              : index === 2
                ? "Diag3"
                : "Diag4";

        const input = {
          claimid: item.ClaimId + "",
          patientid: item.PatientId + "",
          procedure: item.CPT,
          practiceid: "",
          DOS: item.DOS + "",
          clmnName: clmnName,
        };

        JsonDataArr.push(input);
      });
    });

    const requestData = {
      JsonDataArr: JsonDataArr,
      LoggedInUserDetails: userData,
    };

    var myInput = { sInputJSON: JSON.stringify(requestData) };

    myInput = JSON.stringify(myInput);

    try {
      const response = await fetch(
        APIConstants.BASE_URL + IntelliBillConstants.DeleteclaimICDDetails,
        {
          method: "POST",

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },

          body: myInput,
        },
      );

      if (response.ok) {
        const responseData = await response.json();

        const parsedData = JSON.parse(responseData.d);

        setICDConfirmSaveModal(false);
        handleTableDataClick();
        setDiag1AllCheckbox([]);
        setDiag2AllCheckbox([]);
        setDiag3AllCheckbox([]);
        setDiag4AllCheckbox([]);
      } else {
        console.error("Error sending data to the API");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleSavedRows = async () => {
    setSaveFaxError(false);
    setShowFaxSaveMsg(true);

    if (!selectedCPTList) {
      setSaveFaxError(true);
      setShowFaxSaveMsg(false);
      return;
    }

    setShowFaxError(false);

    let ClaimArray = [];

    try {
      const firstRow = {
        CPTcode: selectedCPTCode || "",
        ICD1: selectedDiag1Value.split(" - ")[0] || "",
        ICD2: selectedDiag2Value.split(" - ")[0] || "",
        ICD3: selectedDiag3Value.split(" - ")[0] || "",
        ICD4: selectedDiag4Value.split(" - ")[0] || "",
        Modifier: selectedModList?.val || selectedModList || "",
        Modifier2: selectedMod2Value?.val || selectedMod2Value || "",
        Modifier3: selectedMod3Value?.val || selectedMod3Value || "",
        Unit: selectedUnitValue || "",
        UnitCharges: selectedUnitChargeValue || "",
        CPTServiceID: 0,
      };

      const allRows =
        rows && rows.length > 0 ? [firstRow, ...rows] : [firstRow];

      const ClaimLineItems = allRows.map((item) => ({
        CPTcode: item.CPTcode || item.CPT || "",
        ICD1: item.ICD1 || item.ICDCode || "",
        ICD2: item.ICD2 || item.ICDCode2 || "",
        ICD3: item.ICD3 || item.ICDCode3 || "",
        ICD4: item.ICD4 || item.ICDCode4 || "",
        Modifier: item.Modifier || item.Mod1 || "",
        Modifier2: item.Modifier2 || item.Mod2 || "",
        Modifier3: item.Modifier3 || item.Mod3 || "",
        Unit: item.Unit || "",
        UnitCharges: item.UnitCharges || item.Unitcharge || "",
        CPTServiceID: 0,
      }));

      // console.log("ClaimLineItems:", ClaimLineItems);

      const firstItem = allRows[0];

      const objClaimAllDetails = {
        PracticeID: userPracticeID,
        PatientID: selectedPatientID || "",
        DOS: formatDOSDate(fromDate) || "",
        ProviderID: selectedProviderSuggestion || "",
        SchedulingProviderID: selectedPracticeProvider,
        SupervisorIndicator: selectedProvidersCategory,
        SupervisorProviderID: selectedFilterProvider || "",
        Insurance: 0,
        PolicyNumber: 0,
        Claim24B: selectedServiceLocation || "",
        Claim32A: selectedBillingNPI || "",
        Claim33A: selectedCMS33a || "",
        Claim33B: selectedCMS33b || "",
        PlaceofService: selectedLocation || "",
        SkipBox32: 0,
        UserID: userData.userID,
        RoleID: userData.roleID,
        IsClaimSplit: false,
        IsScheduleAppointment: true,
        IsPrimarySkipped: 0,
        PatientSecInsurance: 0,
        PatientSecInsurancePolicy: 0,
        PageModule: "intellibill",
        ClaimENote: "",
        objCPTDetails: ClaimLineItems,
      };

      ClaimArray.push(objClaimAllDetails);

      var myInput = JSON.stringify({ objClaim: ClaimArray });
      var myInputData = JSON.stringify(myInput);
      const response = await fetch(
        APIConstants.BASE_URL_BILLING +
        IntelliBillConstants.GetIntelliAddNewClaim,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${sAuthToken}`,
          },
          body: myInputData,
        },
      );

      if (response.ok) {
        const responseData = await response.json();

        setUpdatedTableData(responseData);
        setFilteredTableDetails((prev) => [...prev, ...allRows]);

        setSavedRows(allRows.length);
        setmsgSuccesmodal(true);
        setShowFaxSaveMsg(false);
        setShowFaxError(false);
        setShowFaxModal(false);
        setShowFaxConfirmMsg(true);
        setSearchPatientText("");
        handleTableDataClick();
      } else {
        console.error("Error sending data to the API");
        setShowFaxSaveMsg(false);
      }
      setSelectedRows([]);
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleGetVerifiedEPIN = (enteredEpin) => {
    var sInputJSON = {
      UserID: userData.userID,
      EPIN: enteredEpin,
    };

    var sJSONInput = JSON.stringify(sInputJSON);

    const url = `${APIConstants.SERVICES_URL}${IntelliBillConstants.GetVerifyEPIN}?sInputJSON=${sJSONInput}`;

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.status != 200) {
          console.log("response.status", response.status);
        } else return response.json();
      })
      .then((data) => {
        //  const parsedData = JSON.parse(data);

        setverifiedEpin(data);

        if (data === 1) {
        }
      })
      .catch((error) => {
        console.error("Error fetching :", error);
      });
  };

  const handleClosedClaims = async () => {
    const selectedDataArray = [];

    for (const rowId of closeClaimChecbox) {
      const item = tableDetails.find((row) => row.CPTRowID === rowId);

      if (!item) continue;

      const selectedData = {
        IsLineItemData: 1,
        ClaimID: item.ClaimId,
        PracticeID: userPracticeID,
        CPT: item.CPT,
        PatientID: item.PatientId + "",
        DOS: item.DOS,
      };

      selectedDataArray.push(selectedData);
    }

    let myInput = { objClaim: selectedDataArray };
    myInput = JSON.stringify(myInput);

    myInput = JSON.stringify(myInput);

    try {
      const response = await fetch(
        APIConstants.BASE_URL_BILLING + IntelliBillConstants.CloseClaimCPT,
        {
          method: "POST",

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },

          body: myInput,
        },
      );

      if (response.status === 200) {
        setIsEPINVerifiedModal(true);
      } else {
        console.error("Error sending data to the API");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleEpinChange = (e) => {
    const enteredEpin = e.target.value;
    setEpin(enteredEpin);

    handleGetVerifiedEPIN(enteredEpin);
  };

  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    resetDialogValues();
  }, []);
  //Add the row in DialogBox

  const handleAddRow = () => {
    resetDialogValues();

    if (!selectedCPTList) {
      setShowFaxError(true);
      setSaveFaxError(false);
      setShowFaxSaveMsg(false);
      return;
    }

    setSaveFaxError(false);

    // Create a new row with the selected values
    const newRow = {
      DOS: startDate,
      PatientName: searchPatientText,
      ProvderName: selectedProviderText,
      ProviderId: selectedProviderSuggestion,
      CPT_Code: selectedCPTList,
      CPT: selectedCPTCode,
      patientID: selectedCPTPatientID,
      Mod1: selectedModList ? selectedModList.val : "",
      Mod2: selectedMod2Value ? selectedMod2Value.val : "",
      Mod3: selectedMod3Value ? selectedMod3Value.val : "",
      ICDCode: selectedDiag1ID,
      ICDCode2: selectedDiag2ID,
      ICDCode3: selectedDiag3ID,
      ICDCode4: selectedDiag4ID,
      Unit: selectedUnitValue,
      Unitcharge: selectedUnitChargeValue,
    };

    setRows((prevRows) => [...prevRows, newRow]);

    setSelectedCPTList("");
    setSelectedModList(null);
    resetDialogValues();
  };

  const handleRemoveRow = (index) => {
    // Remove the row at the specified index
    setRows((prevRows) => prevRows.filter((_, i) => i !== index));
    resetDialogValues();
  };

  const handleSave = () => {
    setFilteredTableDetails((prevRows) => [...prevRows, ...rows]);

    setRows([]);

    setShowFaxModal(false);
  };

  const handleSyncedInputChange = (e) => {
    const newValue = e.target.value;
    setSyncedValue(newValue);

    const updatedRows = [...filteredTableDetails];
    unitCheckbox.forEach((index) => {
      updatedRows[index].Unit = newValue;
      let totalCharge = newValue * filteredTableDetails[index].Unitcharge;
      updatedRows[index].TotalCharge = parseFloat(totalCharge.toFixed(2));
    });

    setFilteredTableDetails(updatedRows);
  };

  const handleUnitChange = (rowId, newValue) => {
    setFilteredTableDetails(prev =>
      prev.map(item => {
        if (item.CPTRowID !== rowId) return item;
        const totalCharge =
          newValue * item.Unitcharge;
        return {
          ...item,
          Unit: newValue,
          TotalCharge:
            totalCharge === 0
              ? parseFloat(totalCharge.toFixed(2))
              : totalCharge
        };
      })
    );
  };

  const handleSyncedUnitCharge = (e) => {
    const newValue = e.target.value;
    setSyncedUnitchargeVal(newValue);

    setFilteredTableDetails(prev =>
      prev.map(item => {
        if (!UnitChargeRows.includes(item.CPTRowID))
          return item;
        const totalCharge =
          item.Unit * newValue;
        return {
          ...item,
          Unitcharge: newValue,
          TotalCharge: parseFloat(totalCharge.toFixed(2))
        };
      })
    );
  };

  const handleUnitchargeChange = (rowId, newValue) => {
    setFilteredTableDetails(prev =>
      prev.map(item => {
        if (item.CPTRowID !== rowId) return item;

        const totalCharge =
          item.Unit * newValue;
        return {
          ...item,
          Unitcharge: newValue,
          TotalCharge:
            totalCharge === 0
              ? parseFloat(totalCharge.toFixed(2))
              : totalCharge
        };
      })
    );
  };

  const handleTotalChargeChange = (rowId, newValue) => {
    setFilteredTableDetails(prev =>
      prev.map(item =>
        item.CPTRowID === rowId
          ? {
            ...item,
            TotalCharge:
              newValue === "" ? "" : newValue
          }
          : item
      )
    );
  };

  // const handleTotalChargeKeyDown = (index, e) => {
  //   if (e.key === "Backspace") {
  //     e.preventDefault();
  //     const updatedRows = [...filteredTableDetails];
  //     updatedRows[index].TotalCharge = "";
  //     setFilteredTableDetails(updatedRows);
  //   }
  // };

  const handleRowClick = (index) => {
    setActiveRow(index);
  };

  const handlePrint = () => {
    if (!tableRef.current) return;
    const tableClone = tableRef.current.cloneNode(true);
    const headerCells = tableClone.querySelectorAll("thead th");
    const removeIndexes = [];
    headerCells.forEach((th, index) => {
      const columnKey = columns[index]?.key;
      if (!printColumnVisibility[columnKey]) {
        removeIndexes.push(index);
      }
    });
    removeIndexes.reverse().forEach((colIndex) => {
      const header = tableClone.querySelectorAll("thead th")[colIndex];
      if (header) header.remove();
      tableClone.querySelectorAll("tbody tr").forEach((tr) => {
        if (tr.children[colIndex]) {
          tr.children[colIndex].remove();
        }
      });
    });
    const printWindow = window.open("", "_blank");

    printWindow.document.write(`
    <html>
      <head>
          <title>IntelliBill</title>
          <style>
          * {
  font-size: 14px !important;
  box-sizing: border-box;
}
          body {
  font-family: Arial, sans-serif;
  margin: 10px;
  font-size: 12px !important;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 12px !important;
}

th, td {
  border: 1px solid black;
  padding: 2px 3px !important;
  font-size: 12px !important;
  line-height: 1.2 !important;
}

            .table-container {
              width: 100%;
              overflow-x: auto;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              table-layout: auto; 
              word-wrap: break-word;
            }

            @media print {
            th {
              font-size: 12px; !important
                          border: 1px solid black; !important
            }
            td{
                font-size:12px; !important
              }
              .table-container {
                overflow: visible !important;
              }

              .show-on-print {
                display: inline !important;
                font-weight: normal;
              }


               .hide-on-print {
                display: none !important;
              }

                .show-icon{
                      font-size: 5px;
                      width: 10px;
                    
                    }
              
              .input{
                width: 40px;
                color: black;
              }
  input,
  .hide-on-print,
  svg {
    display: none !important;
  }

  .show-on-print {
    display: inline !important;
  }
            }

              body {
    zoom: 0.75;
  }
            }
          </style>
        </head>
      <body>
        ${tableClone.outerHTML}
        <script>
          window.onload = function(){
            window.print();
          }
          window.onafterprint = function(){
            window.close();
          }
        </script>
      </body>
    </html>
  `);

    printWindow.document.close();
    setShowPrintPopup(false);
  };
  const tableRef = useRef("");
  const getClearingHouseName = (id) => {
    const found = selectClearinghouse.find((n) => n.MCHID == id);
    return found ? found.ClearingHouseName : "";
  };
  const exportToExcel = () => {
    const data = filteredTableDetails.map((item, index) => {
      const insId = selectedInsurances[index];
      const insurance = tableInsDetails.find((ins) => ins.InsId === insId);
      const insuranceName = insurance?.InsureranceCompanyname || "";
      const policyNumber = policyNumbers[index] || "";
      return {
        "#": index + 1,
        Location: item.AppLocationName || "",
        DOS: item.DOS || "",
        "Patient Name (2)": item.PatientName || "",
        "BH/SUD": item.CouAppType || "",
        "DOB (3)": item.DOB || "",
        Insurance: `${policyNumber}\n${insuranceName}`,
        "Rendering Provider (24 J)": item.ProvderName || "",
        "CPT (24 D)": item.CPT || "",
        Mod1: item.Mod1 || "",
        Mod2: item.Mod2 || "",
        Mod3: item.Mod3 || "",
        Diag1: item.ICDCode || "",
        Diag2: item.ICDCode2 || "",
        Diag3: item.ICDCode3 || "",
        Diag4: item.ICDCode4 || "",
        "Unit (24 G)": item.Unit || "",
        "Unit Charge (24 F)": item.Unitcharge || "",
        "Total Charge": item.TotalCharge || "",
        Copay: item.CopayAmount || "",
        "Claim ID": item.ClaimId || "",
        "Clearing House": getClearingHouseName(item.ClearingHouse) || "",
        "Service Loc (24 B)": item.ServiceLocationCode || "",
      };
    });
    exportExcel(data, "IntelliBill", "IntelliBill");
  };

  const exportToPDF = async () => {
    const pagename = "IntelliBill";

    setVisibleRecords(filteredTableDetails.length);

    const prevVisibleCount = visibleRecords;

    setTimeout(() => {
      const table = tableRef.current?.parentNode;
      if (!table) return;

      let sPrintableData = table.innerHTML;

      const container = document.createElement("div");
      container.innerHTML = sPrintableData;
      container.querySelectorAll(".hide-on-print").forEach((el) => el.remove());
      container.querySelectorAll("input[type='checkbox']").forEach(el => el.remove());
      container.querySelectorAll("select").forEach(el => el.remove());
      sPrintableData = container.innerHTML;

      const vRegEx = new RegExp("gvClosedClaims", "g");
      sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");

      const PrintableDataDetails = {
        PrintableData: sPrintableData,
        PageName: pagename,
      };

      const InputJSON = JSON.stringify(JSON.stringify(PrintableDataDetails));

      fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExportPdfFile, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: InputJSON,
      })
        .then((res) => res.json())
        .then((data) => {
          if (data?.[2]) {
            window.open(data[2], "_blank");
          }
        })
        .catch((err) => console.error("Export to PDF failed", err))
        .finally(() => {
          setVisibleRecords(prevVisibleCount);
        });
    }, 100);
  };

  const GetProviderPDF = (item) => {
    const claimFilters = {
      PracticeID: userPracticeID,
      PatientID: item.PatientId,
      DOS: item.DOS,
      CPT: item.CPT,
    };

    const sInputJSON = JSON.stringify({ objPatDetails: claimFilters });

    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.CPTDcoument}?sInputJSON=${sInputJSON}`;

    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${sAuthToken}`,
      },
    })
      .then((response) => response.json()) // Parse the response as JSON
      .then((data) => {
        //if (data.status==200)
        {
          const url = JSON.parse(data);
          window.open(url.DocumentURL, "_blank");
        }
      })
      .catch((error) => {
        console.error(" PDF failed", error);
      });
  };

  // useEffect(() => {

  // }, [selectedCMS33a]);

  // useEffect(() => {

  // }, [selectedCMS33b]);

  const handleDosLinkClick = (item) => {
    const claimId = item.ClaimId;

    localStorage.setItem("selectedClaimItem", JSON.stringify(item));

    const url = `/#/transactionlogs/${claimId}`;
    window.open(url, "_blank");
  };

  const handlePatLinkClick = (item) => {
    const url = `/#/patient-dashboard/${item.PatientId}/primary-insurance`;

    localStorage.setItem("PatientId", item.PatientId);

    window.open(url, "_blank");
  };

  const handleLinkClick = (item) => {
    const url = `/#/new-encounter/${item.ClaimId}`;
    window.open(url, "_blank");
  };

  const handleSort = (key, accessor) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedData = [...filteredTableDetails].sort((a, b) => {
      let aValue = accessor ? accessor(a) : a[key];
      let bValue = accessor ? accessor(b) : b[key];

      if (aValue == null) aValue = 0;
      if (bValue == null) bValue = 0;

      if (
        key.toLowerCase().includes("date") ||
        key.toLowerCase().includes("dob") ||
        key.toLowerCase().includes("dos")
      ) {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      } else if (!isNaN(aValue) && !isNaN(bValue)) {
        aValue = parseFloat(aValue) || 0;
        bValue = parseFloat(bValue) || 0;
      } else if (typeof aValue === "string") {
        aValue = aValue.toUpperCase();
        bValue = typeof bValue === "string" ? bValue.toUpperCase() : "";
      }

      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });

    setSortConfig({ key, direction });
    setFilteredTableDetails(addSelectedInsuranceName(sortedData));
  };

  useEffect(() => {
    // Filter the tableDetails based on both search terms

    const filteredData = tableDetails.filter(
      (item) =>
        // Filter by DOS
        (!searchByDOS ||
          (item.DOS &&
            typeof item.DOS === "string" &&
            item.DOS.toLowerCase().includes(searchByDOS.toLowerCase()))) &&
        // Filter by Patient Name
        (!searchByPatient ||
          (item.PatientName &&
            typeof item.PatientName === "string" &&
            (item.PatientName.toLowerCase().startsWith(
              searchByPatient.toLowerCase(),
            ) ||
              item.PatientName.toLowerCase().includes(
                ` ${searchByPatient.toLowerCase()}`,
              )))) &&
        (!searchBySUD ||
          (item.ScheduleType &&
            typeof item.ScheduleType === "string" &&
            item.ScheduleType.toLowerCase().includes(
              searchBySUD.toLowerCase(),
            )) ||
          (item.CouAppType &&
            typeof item.CouAppType === "string" &&
            item.CouAppType.toLowerCase().includes(
              searchBySUD.toLowerCase(),
            ))) &&
        // Filter by DOB
        (!searchByDOB ||
          (item.DOB &&
            typeof item.DOB === "string" &&
            item.DOB.toLowerCase().includes(searchByDOB.toLowerCase()))) &&
        // Filter by Provider Name
        (!searchByProvider ||
          (item.ProvderName &&
            typeof item.ProvderName === "string" &&
            item.ProvderName.toLowerCase().includes(
              searchByProvider.toLowerCase(),
            ))) &&
        // Filter by CPT Code
        (!searchByCPT ||
          (item.CPT &&
            typeof item.CPT === "string" &&
            item.CPT.toLowerCase().includes(searchByCPT.toLowerCase()))) &&
        // Filter by Modifiers
        (!searchByMod1 ||
          (item.Mod1 &&
            typeof item.Mod1 === "string" &&
            item.Mod1.toLowerCase().includes(searchByMod1.toLowerCase()))) &&
        (!searchByMod2 ||
          (item.Mod2 &&
            typeof item.Mod2 === "string" &&
            item.Mod2.toLowerCase().includes(searchByMod2.toLowerCase()))) &&
        (!searchByMod3 ||
          (item.Mod3 &&
            typeof item.Mod3 === "string" &&
            item.Mod3.toLowerCase().includes(searchByMod3.toLowerCase()))) &&
        // Filter by ICD Codes
        (!searchByICD1 ||
          (item.ICDCode &&
            typeof item.ICDCode === "string" &&
            item.ICDCode.toLowerCase().includes(searchByICD1.toLowerCase()))) &&
        (!searchByICD2 ||
          (item.ICDCode2 &&
            typeof item.ICDCode2 === "string" &&
            item.ICDCode2.toLowerCase().includes(
              searchByICD2.toLowerCase(),
            ))) &&
        (!searchByICD3 ||
          (item.ICDCode3 &&
            typeof item.ICDCode3 === "string" &&
            item.ICDCode3.toLowerCase().includes(
              searchByICD3.toLowerCase(),
            ))) &&
        (!searchByICD4 ||
          (item.ICDCode4 &&
            typeof item.ICDCode4 === "string" &&
            item.ICDCode4.toLowerCase().includes(searchByICD4.toLowerCase()))),
    );

    setFilteredTableDetails(
      searchByDOS ||
        searchByPatient ||
        searchByDOB ||
        searchByProvider ||
        searchBySUD ||
        searchByCPT ||
        searchByMod1 ||
        searchByMod2 ||
        searchByMod3 ||
        searchByICD1 ||
        searchByICD2 ||
        searchByICD3 ||
        searchByICD4
        ? filteredData
        : tableDetails,
    );
  }, [
    tableDetails,
    searchByDOS,
    searchByPatient,
    searchByDOB,
    searchByProvider,
    searchByCPT,
    searchBySUD,
    searchByMod1,
    searchByMod2,
    searchByMod3,
    searchByICD1,
    searchByICD2,
    searchByICD3,
    searchByICD4,
  ]);

  useEffect(() => {
    let totalUnit = 0;
    let totalCharge = 0;

    filteredTableDetails.forEach((item) => {
      totalUnit += Number(item.UnitCharge || 0);
      totalCharge += Number(item.TotalCharge || 0);
    });
  }, [filteredTableDetails]);

  useEffect(() => {
    const initialSelectedInsurances = {};
    const initialPolicyNumbers = {};

    const updatedFilteredTableDetails = tableDetails.filter((item) => {
      const rowId = item.CPTRowID;
      const patientInsurances = insuranceMap[item.PatientId] || [];

      let defaultInsurance;

      if (item.PolicyNumber) {
        defaultInsurance = patientInsurances.find(
          (ins) =>
            ins.PolicyNumber === item.PolicyNumber &&
            new Date(item.DOS) >= new Date(ins.insStartDate) &&
            new Date(item.DOS) <= new Date(ins.insEndDate),
        );
      }

      if (!defaultInsurance) {
        defaultInsurance = patientInsurances.find(
          (ins) =>
            ins.InsType == 1 &&
            new Date(item.DOS) >= new Date(ins.insStartDate) &&
            new Date(item.DOS) <= new Date(ins.insEndDate),
        );
      }

      if (!defaultInsurance) {
        defaultInsurance = patientInsurances.find(
          (ins) =>
            new Date(item.DOS) >= new Date(ins.insStartDate) &&
            new Date(item.DOS) <= new Date(ins.insEndDate),
        );
      }

      if (defaultInsurance) {
        initialSelectedInsurances[rowId] = defaultInsurance.InsId;
        initialPolicyNumbers[rowId] = defaultInsurance.PolicyNumber || "";
      } else {
        initialSelectedInsurances[rowId] = "";
        initialPolicyNumbers[rowId] = "";
      }

      // 🔎 Apply Insurance Search Filter
      return (
        defaultInsurance?.InsureranceCompanyname?.toLowerCase().startsWith(
          searchByInsuranceID.toLowerCase(),
        ) || searchByInsuranceID === ""
      );
    });

    setSelectedInsurances(initialSelectedInsurances);
    setPolicyNumbers(initialPolicyNumbers);
    setFilteredTableDetails(updatedFilteredTableDetails);
  }, [tableDetails, insuranceMap, searchByInsuranceID]);

  const handleInsuranceChange = (item, selectedValue) => {
    const rowId = item.CPTRowID;

    setSelectedInsurances((prev) => ({
      ...prev,
      [rowId]: selectedValue,
    }));

    const matchingPolicy = tableInsDetails.find((ins) => {
      return (
        String(ins.InsId) === String(selectedValue) &&
        String(ins.PatientId) === String(item.PatientId) &&
        new Date(item.DOS).getTime() >= new Date(ins.insStartDate).getTime() &&
        new Date(item.DOS).getTime() <= new Date(ins.insEndDate).getTime()
      );
    });

    setPolicyNumbers((prev) => ({
      ...prev,
      [rowId]: matchingPolicy ? matchingPolicy.PolicyNumber : "",
    }));
  };

  const handleApplyCopayData = (item) => {
    var inputStruct = {
      ClaimID: item.ClaimId,
      PostingCharges: item.CopayAmount,
      PracticeID: userPracticeID,
      CPT: item.CPT,
      DOS: item.DOS,
      PatientID: item.PatientId,
      UpdatedBy: userData.userID,
      CopayType: "Cash",
    };

    var myInputData = JSON.stringify(JSON.stringify({ objClaim: inputStruct }));

    const response = fetch(
      APIConstants.BASE_URL_BILLING + CommonAPIConstants.ApplyCopay,
      {
        method: "POST",

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${sAuthToken}`,
        },

        body: myInputData,
      },
    )
      .then((response) =>
        response.json().then((data) => ({ ok: response.ok, data })),
      )
      .then(({ ok, data }) => {
        if (ok) {
          const updatedClaims = filteredTableDetails.map((claim) => {
            if (claim.ClaimId == item.ClaimId) {
              return {
                ...claim,
                CopayAppliedClaim: item.ClaimId,
                CopayApliedByShortName: item.CopayApliedByShortName,
                CopayApliedOn: item.CopayApliedOn,
              };
            }
            return claim;
          });

          setFilteredTableDetails(updatedClaims);
          const successMsg = `Copay amount ${item.CopayAmount} applied to claim ${item.ClaimId}`;
          setErrorMessage(successMsg);
        }
      })
      .catch((error) => {
        console.error("An error occurred:", error);
      });
  };

  const inputRef = useRef(null);
  const suggestionsRef = useRef(null);

  const handleClickOutside = (event) => {
    if (
      inputRef.current &&
      !inputRef.current.contains(event.target) &&
      suggestionsRef.current &&
      !suggestionsRef.current.contains(event.target)
    ) {
      setSuggestions([]);
    }
  };

  useEffect(() => {
    if (suggestions.length > 0) {
      // Only add the event listener when suggestions are visible
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      // Remove event listener when suggestions are hidden
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Cleanup: Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [suggestions]);

  // useEffect(() => {
  //   const enhancedDetails = filteredTableDetails.map((item, index) => {
  //     const selectedInsId = selectedInsurances[index];
  //     const matchedIns = tableInsDetails.find(ins => ins.InsId === selectedInsId);
  //     return {
  //       ...item,
  //       SelectedInsuranceName: matchedIns?.InsureranceCompanyname || '',
  //     };
  //   });

  //   setFilteredTableDetails(enhancedDetails);
  // }, [selectedInsurances, tableInsDetails]);

  const addSelectedInsuranceName = (details) => {
    return details.map((item, index) => {
      const selectedInsId = selectedInsurances[index];
      const matchedIns = tableInsDetails.find(
        (ins) => ins.InsId === selectedInsId,
      );
      return {
        ...item,
        SelectedInsuranceName: matchedIns?.InsureranceCompanyname || "",
      };
    });
  };

  // const getRowHeight = index => {

  //   const item = filteredTableDetails[index];
  //   return item?.DataValidationMessage ? 100 : 50;
  // };

  return (
    <>
      <div className="main-container">
        <div className="container-style">
          <div className="topnavmenu">
            <label className="active-label">IntelliBill</label>
          </div>

          <div className="table_style">
            <div className="intelli-row-style ">
              <div
                className="datepicker-container mt-1 d-flex"
                style={{ marginLeft: "1px", position: "relative", zIndex: 10 }}
              >
                <label style={{ width: "40px" }}>From:</label>
                <DatePicker
                  selected={startDate ? new Date(startDate) : null}
                  onChange={handleStartDateChange}
                  dateFormat="MM/dd/yyyy"
                  maxDate={new Date()}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  yearDropdownItemNumber={100}
                  readOnly={isHideChecked}
                  className={`clnImgTextBoxes ${startDate ? "default-selected" : ""}`}
                  placeholderText="MM/dd/yyyy"
                  calendarContainer={CalendarStartContainer}
                  open={isStartOpen}
                  onFocus={() => setIsStartOpen(true)}
                  onInputClick={() => setIsStartOpen(true)}
                  onClickOutside={() => setIsStartOpen(false)}
                  renderCustomHeader={({
                    date,
                    changeYear,
                    changeMonth,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled,
                  }) => {
                    const selectedDate =
                      date instanceof Date && !isNaN(date) ? date : new Date();
                    const selectedMonth = selectedDate.getMonth();
                    const selectedYear = selectedDate.getFullYear();

                    return (
                      <div>
                        <button
                          onClick={decreaseMonth}
                          disabled={prevMonthButtonDisabled}
                          style={{ height: "25px" }}
                        >
                          {"<"}
                        </button>
                        <select
                          value={selectedMonth}
                          onChange={({ target: { value } }) =>
                            changeMonth(Number(value))
                          }
                        >
                          {getMonths(selectedYear)}
                        </select>
                        <select
                          value={selectedYear}
                          onChange={({ target: { value } }) =>
                            changeYear(Number(value))
                          }
                        >
                          {Array.from({ length: 100 }, (v, k) => (
                            <option
                              key={k}
                              value={new Date().getFullYear() - k}
                            >
                              {new Date().getFullYear() - k}
                            </option>
                          ))}
                        </select>
                        <button
                          onClick={increaseMonth}
                          disabled={nextMonthButtonDisabled}
                          style={{ height: "25px" }}
                        >
                          {">"}
                        </button>
                      </div>
                    );
                  }}
                />
              </div>

              <div
                className="datepicker-container  mt-1 d-flex"
                style={{ marginLeft: "10px", position: "relative", zIndex: 10 }}
              >
                <label>To: </label>
                <DatePicker
                  selected={endDate ? new Date(endDate) : null}
                  onChange={handleEndDateChange}
                  dateFormat="MM/dd/yyyy"
                  maxDate={new Date()}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  yearDropdownItemNumber={100}
                  className={`clnImgTextBoxes ${endDate ? "default-selected" : ""}`}
                  placeholderText="MM/dd/yyyy"
                  popperPlacement="bottom-start"
                  readOnly={isHideChecked}
                  calendarContainer={CalendarContainer}
                  open={isEndOpen}
                  onFocus={() => setIsEndOpen(true)}
                  onInputClick={() => setIsEndOpen(true)}
                  onClickOutside={() => setIsEndOpen(false)}
                  renderCustomHeader={({
                    date,
                    changeYear,
                    changeMonth,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled,
                  }) => {
                    const selectedDate =
                      date instanceof Date && !isNaN(date) ? date : new Date();
                    const selectedMonth = selectedDate.getMonth();
                    const selectedYear = selectedDate.getFullYear();

                    return (
                      <div>
                        <button
                          onClick={decreaseMonth}
                          disabled={prevMonthButtonDisabled}
                          style={{ height: "25px" }}
                        >
                          {"<"}
                        </button>
                        <select
                          value={selectedMonth}
                          onChange={({ target: { value } }) =>
                            changeMonth(Number(value))
                          }
                        >
                          {getMonths(selectedYear)}
                        </select>
                        <select
                          value={selectedYear}
                          onChange={({ target: { value } }) =>
                            changeYear(Number(value))
                          }
                        >
                          {Array.from({ length: 100 }, (v, k) => (
                            <option
                              key={k}
                              value={new Date().getFullYear() - k}
                            >
                              {new Date().getFullYear() - k}
                            </option>
                          ))}
                        </select>
                        <button
                          onClick={increaseMonth}
                          disabled={nextMonthButtonDisabled}
                          style={{ height: "25px" }}
                        >
                          {">"}
                        </button>
                      </div>
                    );
                  }}
                />
              </div>

              <div style={{ display: "flex", marginLeft: "20px" }}>
                <label style={{ width: "80px", marginTop: "3px" }}>
                  Hide Dates
                </label>
                <input
                  style={{
                    position: "absolute",
                    marginLeft: "90px",
                    marginTop: "10px",
                  }}
                  type="checkbox"
                  checked={isHideChecked}
                  onChange={handleHideCheckboxChange}
                />
              </div>

              <div className="search-style  mt-1 d-flex">
                <label style={{ width: "80px" }}>Search By:</label>
                <select
                  name="select"
                  className="select-style"
                  value={selectedSearchFilter}
                  onChange={handleSuggestionChange}
                >
                  <option value="">&lt;--Select--&gt;</option>
                  {searchFilterData.map((item, index) => (
                    <option key={item.sFilterType} value={item.sFilterType}>
                      {item.Label}
                    </option>
                  ))}
                </select>
              </div>

              <div
                style={{ marginLeft: "10px", marginTop: "3px", width: "100px" }}
              >
                <input
                  type="text"
                  value={searchText}
                  ref={inputRef}
                  onChange={(e) => setSearchText(e.target.value)}
                  onKeyDown={handleInputKeyPress}
                  disabled={isTextBoxDisabled}
                  style={{ width: "140px", border: "1px solid lightgray" }}
                />
                <div
                  className="autocomplete"
                  style={{ zIndex: 99 }}
                  ref={suggestionsRef}
                >
                  <ul className="list-style">
                    {suggestions.map((suggestion) => (
                      <li
                        key={suggestion.val}
                        onClick={() => handleSuggestionSelect(suggestion)}
                      >
                        {suggestion.label}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div>
                <select
                  name="select"
                  className="select-style3  mt-1"
                  style={{
                    width: "150px",
                    backgroundColor:
                      searchByLoaction !== "-1"
                        ? locations.find(
                          (loc) => loc.LocationId == searchByLoaction,
                        )?.Color || "#fff"
                        : "#fff",
                  }}
                  value={searchByLoaction}
                  onChange={handleLocationChange}
                >
                  <option value="-1">All</option>

                  {locations.map((item, index) => (
                    <option
                      key={index}
                      value={item.LocationId}
                      style={{ backgroundColor: item.Color }}
                    >
                      {item.LocationName}
                    </option>
                  ))}
                </select>
              </div>

              <div
                style={{
                  marginLeft: "40px",
                  marginTop: "3px",
                  display: "flex",
                }}
              >
                <input
                  type="checkbox"
                  checked={isClosedClaim}
                  onChange={handleCloseClaimCheckbox}
                />

                <label
                  style={{
                    width: "150px",
                    marginLeft: "4px",
                    marginTop: "4px",
                  }}
                >
                  Show Closed Claims
                </label>
              </div>

              <div style={{ marginLeft: "20px", marginTop: "5px" }}>
                <FontAwesomeIcon
                  style={{
                    cursor: "pointer",
                    fontSize: "1.5rem",
                    padding: "4px",
                  }}
                  onClick={(e) => handleTableDataClick(e)}
                  icon={faMagnifyingGlass}
                />
              </div>
            </div>
          </div>

          <div className="table-primary row-style">
            <div className="intelli-row-style">
              <div className="d-flex input-style2">
                <label style={{ width: "210px" }}>
                  Service location address(32)
                  <span style={{ color: "Red" }}>*</span>
                </label>
                <select
                  name="select"
                  className={`select-style2 mt-1 ${selectedLocation === "0" ? "red-bg" : "green-bg"}`}
                  value={selectedLocation}
                  onChange={(e) => setSelectedLocation(e.target.value)}
                >
                  <option value="0">&lt;--Select--&gt;</option>
                  {locations.map((item, index) => (
                    <option
                      style={{ width: "100px" }}
                      value={item.LocationId}
                      key={index}
                    >
                      {item.LocationName}
                    </option>
                  ))}
                </select>
              </div>

              <div className="d-flex input-style3">
                <label style={{ width: "210px" }}>
                  Service Location NPI:(32 a)
                  <span style={{ color: "Red" }}>*</span>
                </label>
                <select
                  name="select"
                  className={`option1 mt-1 ${selectedBillingNPI === "0" ? "red-bg" : "green-bg"}`}
                  value={selectedBillingNPI}
                  onChange={handleSelectBillingNPI}
                >
                  <option value="0">&lt;--Select--&gt;</option>
                  {BillingNPIs.map((item, index) => (
                    <option value={item.NPI} key={index}>
                      {item.NamewithNPI}
                    </option>
                  ))}
                </select>
              </div>

              {/* <div className='vl-2'></div> */}

              <div style={{ marginLeft: "10px" }}>
                <select
                  name="select"
                  id=""
                  className="option3 mt-1"
                  value={selectedProvidersCategory}
                  onChange={(e) => setSelectedProvidersCategory(e.target.value)}
                >
                  {providerCategory.map((item, index) => (
                    <option value={item.Value}>{item.Label}</option>
                  ))}
                </select>
                (17)
              </div>

              <div className="mt-1" style={{ marginLeft: "" }}>
                <select
                  name="select"
                  className="option3"
                  onChange={handleSelectFilterProviders}
                  value={selectedFilterProvider}
                >
                  <option value="">&lt;--Select--&gt;</option>

                  {filteredProviders.map((provider) => (
                    <option
                      key={provider.ProviderID}
                      value={provider.ProviderID}
                    >
                      {provider.ProviderName}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="intelli-row-style mt-2">
              <div className="d-flex input-style2">
                <label style={{ width: "210px" }}>
                  Billing Provider NPI: (33 a)
                  <span style={{ color: "Red" }}>*</span>
                </label>

                <select
                  name="select"
                  className={`select-style2 ${selectedCMS33a === "0" ? "red-bg" : "green-bg"}`}
                  value={selectedCMS33a}
                  onChange={(e) => setSelectedCMS33a(e.target.value)}
                >
                  <option value="0">&lt;--Select--&gt;</option>
                  {cms33aData.map((item, index) => (
                    <option key={index} value={item.NPI}>
                      {item.NamewithNPI}
                    </option>
                  ))}
                </select>

                <div className="d-flex input-style3">
                  <label style={{ width: "290px" }}>
                    Billing Provider Taxonomy code:(33 b)
                    <span style={{ color: "Red" }}>*</span>
                  </label>

                  <select
                    name="select"
                    id=""
                    className={`option2 ${selectedCMS33b === "0" ? "red-bg" : "green-bg"}`}
                    value={selectedCMS33b}
                    onChange={(e) => setSelectedCMS33b(e.target.value)}
                  >
                    <option value="0">&lt;--Select--&gt;</option>
                    {cms33bData.map((item, index) => (
                      <option
                        style={{ width: "100px" }}
                        key={index}
                        value={item.TaxonomyCode}
                      >
                        {item.NamewithTaxCode}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="d-flex">
                  <label style={{ width: "160px", marginLeft: "10px" }}>
                    Scheduling Provider
                    <span style={{ color: "Red" }}>*</span>
                  </label>

                  <ProviderDropdown
                    rawData={practiceProvider}
                    selectedProvider={selectedPracticeProvider}
                    setSelectedProvider={setSelectedPracticeProvider}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row-style">
            <div className="radio-container">
              <div className="radio-row-style2">
                <div className="intelli-row-style2">
                  {statusRadioButton.map((item, index) => (
                    <div className="radio-style" key={index}>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          value={item.ClaimStatus}
                          onChange={handleClaimStatusChange}
                          checked={
                            selectedStatusRadioButton === item.ClaimStatus
                          }
                        />
                        <label style={{ width: "max-content" }}>
                          {item.Label}
                        </label>
                      </div>
                    </div>
                  ))}

                  <div className="icon-container">
                    <FontAwesomeIcon
                      style={{ cursor: "pointer" }}
                      onClick={openPrintPopup}
                      icon={faPrint}
                    />
                    <FontAwesomeIcon
                      style={{
                        marginLeft: "8px",
                        color: "green",
                        cursor: "pointer",
                      }}
                      onClick={exportToExcel}
                      icon={faFileExcel}
                    />
                    <FontAwesomeIcon
                      style={{
                        marginLeft: "8px",
                        color: "red",
                        cursor: "pointer",
                      }}
                      onClick={exportToPDF}
                      icon={faFilePdf}
                    />
                  </div>
                </div>
              </div>

              {loading && (
                <div className="overlay">
                  <div className="spinner-container">
                    <div className="spinner-grow text-danger" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <div className="spinner-grow text-warning" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <div className="spinner-grow text-info" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </div>
              )}
              <button
                className="btn-style mt-1 hide-on-print"
                style={{ marginLeft: "110px" }}
                onClick={handleOpenApprovalModal}
              >
                Save for Approval
              </button>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  padding: "10px 20px",
                  backgroundColor: "#f9f9f9",
                  borderRadius: "8px",
                  boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)",
                  width: "fit-content",
                  marginTop: "5px",
                  fontSize: "1.2rem",
                  marginLeft: "50px",
                  height: "30px",
                }}
              >
                <span style={{ fontWeight: "600", color: "#333" }}>
                  Total Records:
                </span>
                <span style={{ fontWeight: "700", color: "#007bff" }}>
                  {filteredTableDetails.length}
                </span>
              </div>
            </div>
          </div>
          {/* <div className="column-selector" style={{ marginBottom: "20px", width: "45%" }}>
            {columns.map((col) => (
              <label key={col.key} style={{ marginRight: "30px", fontSize: "17px" }}>
                <input
                  type="checkbox"
                  // style={{fontSize:"19px" }}
                  checked={selectedColumns.includes(col.key)}
                  onChange={() => toggleColumn(col.key)}
                />{" "}
                {col.label}
              </label>
            ))}
          </div> */}

          <div className="table-container">
            <table
              className="fixed-header table-info  table table-hover  table-bordered border-secondary border-white "
              ref={tableRef}
            >
              <thead style={{ marginLeft: "20px" }}>
                <tr
                  className="align-top"
                  style={{ position: "sticky", top: 0, zIndex: 9999 }}
                >
                  {columns.map((col) =>
                    selectedColumns.includes(col.key) ? (
                      <th
                        key={col.key}
                        className="border-white text-white"
                        style={{
                          backgroundColor: "#0173b7",
                          fontSize: "16px",
                          fontWeight: 600,
                          padding: "4px 6px",
                          whiteSpace: "nowrap",
                          minWidth: col.minWidth || "80px",
                        }}
                      >
                        {col.isLink ? (
                          <Link
                            className="text-white"
                            onClick={() => handleSort(col.key)}
                          >
                            {col.label}
                          </Link>
                        ) : (
                          col.label
                        )}
                        {col.hasSearch && (
                          <div>
                            <input
                              className="hide-on-print"
                              type="text"
                              placeholder="Search"
                              value={col.searchValue}
                              onChange={(e) =>
                                col.setSearchValue(e.target.value)
                              }
                              style={{
                                width: "90px",
                                height: "25px",
                                marginTop: "2px",
                                borderRadius: "4px",
                              }}
                            />
                          </div>
                        )}
                        {col.hasCheckbox && (
                          <div>
                            <input
                              className="hide-on-print"
                              type="checkbox"
                              checked={col.checkboxValue}
                              onChange={col.onCheckboxChange}
                              style={{ marginTop: "2px" }}
                            />
                          </div>
                        )}
                        {col.hasButton && (
                          <div style={{ marginTop: "2px" }}>
                            {col.buttons?.map((btn, i) => (
                              <button
                                key={i}
                                className={btn.className}
                                style={{ marginLeft: i > 0 ? "4px" : "0" }}
                                onClick={btn.onClick}
                              >
                                {btn.label}
                              </button>
                            ))}
                          </div>
                        )}
                        {col.hasSelect && (
                          <div>
                            <select
                              className="hide-on-print"
                              value={col.selectValue}
                              onChange={(e) =>
                                col.onSelectChange(e.target.value)
                              }
                              style={{ marginTop: "2px", width: "90px" }}
                            >
                              <option value="">--Select--</option>
                              {col.selectOptions?.map((opt, i) => (
                                <option key={i} value={opt.value}>
                                  {opt.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}
                        {col.headerExtra && (
                          <div style={{ marginTop: "4px" }}>
                            {col.headerExtra}
                          </div>
                        )}
                        {col.headerCheckbox && (
                          <input
                            type="checkbox"
                            className="hide-on-print"
                            // checked={col.headerCheckbox.checked || false}
                            onChange={col.headerCheckbox.onChange}
                            style={{ marginLeft: "3px" }}
                          />
                        )}
                      </th>
                    ) : null,
                  )}
                </tr>
              </thead>

              <tbody>
                <tr className="align-top table-secondary hide-on-print">
                  {columns.map((col, idx) => {
                    if (!selectedColumns.includes(col.key)) return null;
                    switch (col.key) {
                      case "PatientName":
                        return (
                          <td key={col.key} className="border-white">
                            <FontAwesomeIcon
                              className="search-icon"
                              icon={faMagnifyingGlass}
                            />
                            <input
                              type="text"
                              className="search-box-style"
                              placeholder="Add Patient"
                              value={searchPatientText}
                              onChange={(e) =>
                                setSearchPatientText(e.target.value)
                              }
                              onKeyDown={handleKeyDown}
                            />
                            {searchPatientText.length > 0 && (
                              <div className="autocomplete">
                                <ul
                                  className="list-style"
                                  style={{ width: "150px", color: "black" }}
                                >
                                  {Array.isArray(searchPatientData) &&
                                    searchPatientData.map((s) => (
                                      <li
                                        key={s.val}
                                        onClick={() =>
                                          handlePatientSuggestion(s)
                                        }
                                      >
                                        {s.label}
                                      </li>
                                    ))}
                                </ul>
                              </div>
                            )}
                          </td>
                        );
                      case "ProvderName":
                        return (
                          <td key={col.key} className="border-white">
                            <FontAwesomeIcon
                              className="search-icon"
                              icon={faMagnifyingGlass}
                            />
                            <input
                              type="text"
                              className="search-box-style"
                              placeholder="Add Provider"
                              value={selectedProviderData}
                              onChange={(e) =>
                                setselectedProviderData(e.target.value)
                              }
                              onKeyDown={handleProviderKeyDown}
                            />
                            <div className="autocomplete">
                              <ul
                                className="list-style"
                                style={{ width: "150px", color: "black" }}
                              >
                                {Array.isArray(suggestionProviders) &&
                                  suggestionProviders.map((s) => (
                                    <li
                                      key={s.val}
                                      onClick={() =>
                                        handleProviderSuggestion(s)
                                      }
                                    >
                                      {s.label}
                                    </li>
                                  ))}
                              </ul>
                            </div>
                          </td>
                        );

                      case "CPT":
                        return (
                          <td key={col.key} className="border-white">
                            <FontAwesomeIcon
                              className="search-icon"
                              icon={faMagnifyingGlass}
                            />
                            <input
                              type="text"
                              className="search-box-style"
                              placeholder="Add Procedure"
                              value={selectedCptValue}
                              onChange={(e) =>
                                setSelectedCptValue(e.target.value)
                              }
                              onKeyUp={handleCPTKeyDown}
                            />
                            <ul
                              className="list-style"
                              style={{
                                width: "180px",
                                color: "black",
                                fontSize: "0.8rem",
                                position: "sticky",
                                zIndex: 9999,
                              }}
                            >
                              {Array.isArray(cptValueList) &&
                                cptValueList.map((s) => (
                                  <li
                                    key={s.CPT_Code}
                                    onClick={() => handleCPTList(s)}
                                  >
                                    {s.CPT_Code}-{s.CPTDescription}
                                  </li>
                                ))}
                            </ul>
                          </td>
                        );

                      case "Mod1":
                      case "Mod2":
                      case "Mod3":
                        const modListMap = {
                          Mod1: mod1List,
                          Mod2: mod2List,
                          Mod3: mod3List,
                        };
                        const selectedModMap = {
                          Mod1: selectedMod1Value,
                          Mod2: selectedMod2ListVal,
                          Mod3: selectedMod3ListVal,
                        };
                        const setSelectedMap = {
                          Mod1: setSelectedMod1Value,
                          Mod2: setSelectedMod2ListVal,
                          Mod3: setSelectedMod3ListVal,
                        };
                        return (
                          <td key={col.key} className="border-white">
                            <FontAwesomeIcon
                              className="search-icon"
                              icon={faMagnifyingGlass}
                            />
                            <input
                              type="text"
                              className="search-box-style"
                              placeholder={`Add ${col.key}`}
                              value={selectedModMap[col.key]}
                              onChange={(e) =>
                                setSelectedMap[col.key](e.target.value)
                              }
                              onKeyUp={
                                col.key === "Mod1"
                                  ? handleMod1ListKeyDown
                                  : col.key === "Mod2"
                                    ? handleMod2KeyDown
                                    : handleMod3KeyDown
                              }
                            />
                            <ul
                              className="list-style"
                              style={{
                                width: "100px",
                                color: "black",
                                fontSize: "0.8rem",
                                position: "sticky",
                                zIndex: 9999,
                              }}
                            >
                              {Array.isArray(modListMap[col.key]) &&
                                modListMap[col.key].map((s) => (
                                  <li
                                    key={s.val}
                                    onClick={() =>
                                      col.key === "Mod1"
                                        ? handleMod1List(s)
                                        : col.key === "Mod2"
                                          ? handleMod2Data(s)
                                          : handleMod3Data(s)
                                    }
                                  >
                                    {s.val != null ? (
                                      s.val
                                    ) : (
                                      <span style={{ color: "red" }}>
                                        Invalid Value
                                      </span>
                                    )}
                                    -
                                    {s.val != null ? (
                                      s.val
                                    ) : (
                                      <span style={{ color: "red" }}>
                                        Invalid Value
                                      </span>
                                    )}
                                  </li>
                                ))}
                            </ul>
                          </td>
                        );

                      case "ICDCode":
                      case "ICDCode2":
                      case "ICDCode3":
                      case "ICDCode4":
                        const diagListMap = {
                          ICDCode: diag1List,
                          ICDCode2: diag2List,
                          ICDCode3: diag3List,
                          ICDCode4: diag4List,
                        };
                        const selectedDiagMap = {
                          ICDCode: selectedDiag1List,
                          ICDCode2: selectedDiag2List,
                          ICDCode3: selectedDiag3List,
                          ICDCode4: selectedDiag4List,
                        };
                        const setSelectedDiagMap = {
                          ICDCode: setSelectedDiag1List,
                          ICDCode2: setSelectedDiag2List,
                          ICDCode3: setSelectedDiag3List,
                          ICDCode4: setSelectedDiag4List,
                        };
                        return (
                          <td key={col.key} className="border-white">
                            <FontAwesomeIcon
                              className="search-icon"
                              icon={faMagnifyingGlass}
                            />
                            <input
                              type="text"
                              className="search-box-style"
                              placeholder={`Add ${col.label}`}
                              value={selectedDiagMap[col.key]}
                              onChange={(e) =>
                                setSelectedDiagMap[col.key](e.target.value)
                              }
                              onKeyUp={
                                col.key === "ICDCode"
                                  ? handleDiag1DataKeyDown
                                  : col.key === "ICDCode2"
                                    ? handleDiag2DataKeyDown
                                    : col.key === "ICDCode3"
                                      ? handleDiag3DataKeyDown
                                      : handleDiag4DataKeyDown
                              }
                            />
                            <ul
                              className="list-style"
                              style={{
                                width: "200px",
                                color: "black",
                                fontSize: "0.8rem",
                                position: "sticky",
                                zIndex: 9999,
                              }}
                            >
                              {Array.isArray(diagListMap[col.key]) &&
                                diagListMap[col.key].map((s) => (
                                  <li
                                    key={s.Value}
                                    onClick={() =>
                                      col.key === "ICDCode"
                                        ? handleDiag1DataList(s)
                                        : col.key === "ICDCode2"
                                          ? handleDiag2DataList(s)
                                          : col.key === "ICDCode3"
                                            ? handleDiag3DataList(s)
                                            : handleDiag4DataList(s)
                                    }
                                  >
                                    {s.Value}
                                  </li>
                                ))}
                            </ul>
                          </td>
                        );

                      case "Unit":
                        return (
                          <td key={col.key} className="border-white">
                            <input
                              className="textboxes"
                              style={{ width: "70px" }}
                              type="text"
                              value={syncedValue}
                              onChange={(e) => handleSyncedInputChange(e)}
                            />
                          </td>
                        );

                      case "Unitcharge":
                        return (
                          <td key={col.key} className="border-white">
                            <input
                              className="textboxes"
                              style={{ width: "70px" }}
                              type="text"
                              value={syncedUnitchargeVal}
                              onChange={(e) => handleSyncedUnitCharge(e)}
                            />
                          </td>
                        );

                      default:
                        return <td key={col.key} className="border-white"></td>;
                    }
                  })}
                </tr>

                {filteredTableDetails
                  .slice(0, visibleRecords)
                  .map((item, index) => {

                    const insDetails = tableInsDetails.filter(
                      (ins) => ins.PatientId === item.PatientId,
                    );

                    const filteredInsDetails = insDetails.filter((ins) =>
                      filteredTableDetails.some(
                        (td) =>
                          new Date(td.DOS) >= new Date(ins.insStartDate) &&
                          new Date(td.DOS) <= new Date(ins.insEndDate),
                      ),
                    );

                    return (
                      <tr
                        key={index}

                        className={
                          item.iClosed == 1
                            ? "table-secondary"
                            : activeRow === index
                              ? "table-warning"
                              : item.DataValidationMessage
                                ? "table-danger"
                                : ""
                        }
                        onClick={() => handleRowClick(index)}
                        style={{
                          backgroundColor:
                            index % 2 === 1 ? "lightblue" : "inherit",
                        }}
                        data-toggle="tooltip"
                        data-placement="top"
                        title={
                          item.DataValidationMessage
                            ? item.DataValidationMessage
                            : item.isReadyforApproval === "0"
                              ? "Claim is not saved for approval"
                              : ""
                        }
                      >
                        {columns.map((col) =>
                          selectedColumns.includes(col.key) ? (
                            <td
                              key={col.key}
                              className="border-white"
                              style={{
                                fontSize: "16px",
                                padding: "4px 6px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {col.render
                                ? col.render(item, index, filteredInsDetails)
                                : item[col.key]}
                            </td>
                          ) : null,
                        )}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            {errorMessage && (
              <div className="alertmsg-modal">
                <label style={{ backgroundColor: "#18A6EC" }}></label>
                <FontAwesomeIcon
                  style={{
                    float: "right",
                    fontWeight: "bolder",
                    fontSize: "1rem",
                    backgroundColor: "red",
                    padding: "5px",
                    cursor: "pointer",
                  }}
                  onClick={handleCloseModals}
                  icon={faXmark}
                />
                <div
                  style={{
                    backgroundColor: "#18A6EC",
                    color: "white",
                    padding: "10px",
                  }}
                >
                  {errorMessage.split("\n").map((msg, index) => (
                    <p key={index} style={{ margin: "4px 0" }}>
                      {msg}
                    </p>
                  ))}
                </div>
              </div>
            )}

            {showCopaySuccessModal && (
              <div className="alertmsg-modal">
                <label style={{ backgroundColor: "#18A6EC" }}></label>
                <FontAwesomeIcon
                  style={{
                    float: "right",
                    fontWeight: "bolder",
                    fontSize: "1rem",
                    backgroundColor: "red",
                    padding: "5px",
                    cursor: "pointer",
                  }}
                  onClick={handleCloseModals}
                  icon={faXmark}
                />
                <div
                  style={{
                    backgroundColor: "#18A6EC",
                    color: "white",
                    padding: "10px",
                  }}
                >
                  {errorMessage}
                </div>
              </div>
            )}

            {showPopup && (
              <div
                style={{
                  position: "fixed",
                  bottom: "50px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "#333",
                  color: "#fff",
                  padding: "10px 20px",
                  borderRadius: "5px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                  zIndex: 1000,
                  height: "100px",
                  width: "400px",
                  textAlign: "center",
                }}
              >
                <label
                  style={{
                    marginTop: "20px",
                    fontSize: "1.4rem",
                    border: "#333",
                  }}
                >
                  {popupMessage}
                </label>
              </div>
            )}

            {showSuccessModal && (
              <div
                className="alertmsg-modal"
                role="alert"
                style={{
                  left: "20%",
                  top: "40%",
                  height: "100px",
                  width: "max-content",
                  fontSize: "1.4rem",
                }}
              >
                {`${savedRowCount}  claim successfully Saved`}!!
                {showSuccessModal}
              </div>
            )}

            {msgSuccesmodal && (
              <div
                className="alert alert-success aleart-modal"
                role="alert"
                style={{ marginLeft: "200px", width: "1000px" }}
              >
                {`${savedRows}  claim successfully Saved`}
              </div>
            )}


            {showSelectErrorModal && (
              <div className="alert-modal">
                <p>please select atleast one claim...</p>
                <button
                  className="btn btn-primary"
                  onClick={handleCloseModals}
                >
                  Ok
                </button>
              </div>
            )}

            {showICDErrorModal && (
              <div className="alert-modal">
                <p>please select ICDs to Delete...</p>
                <button
                  className="btn btn-primary"
                  onClick={handleCloseModals}
                >
                  Ok
                </button>
              </div>
            )}

            {ICDConfirmSaveModal && (
              <div className="alert-modal">
                <p>Delete Selected ICDs?</p>
                <button
                  className="btn btn-primary"
                  onClick={handleCloseModals}
                >
                  close
                </button>
                <button
                  className="btn btn-primary"
                  style={{ marginLeft: "40px" }}
                  onClick={DeleteclaimICDDetails}
                >
                  Delete
                </button>
              </div>
            )}

            {showConfirmSaveModal && (
              <div className="alert-modal">
                <p>Are you sure to save?</p>
                <button
                  className="btn btn-primary"
                  onClick={handleCloseModals}
                >
                  close
                </button>
                <button
                  className="btn btn-primary"
                  style={{ marginLeft: "40px" }}
                  onClick={(e) => handleUpdatedClaims(e, 0)}
                >
                  save
                </button>
              </div>
            )}

            {showApprovalSaveModal && (
              <div className="alert-modal">
                <p>Are you sure to save for approval ?</p>
                <button
                  className="btn btn-primary"
                  onClick={handleCloseModals}
                >
                  close
                </button>
                <button
                  className="btn btn-primary"
                  style={{ marginLeft: "40px" }}
                  onClick={(e) => handleUpdatedClaims(e, 1)}
                >
                  save
                </button>
              </div>
            )}

            {showDeleteModal && (
              <div className="alert-modal">
                <p>Delete only for this session ?</p>
                <button
                  className="btn btn-primary"
                  onClick={handleCloseModals}
                >
                  close
                </button>
                <button
                  className="btn btn-primary"
                  style={{ marginLeft: "40px" }}
                  onClick={handleDelete}
                >
                  Delete
                </button>
              </div>
            )}

            {deleteSuccessModal && (
              <div
                className="alert alert-danger mt-2"
                role="alert"
                style={{ marginLeft: "1200px", width: "1000px" }}
              >
                {`${deleteRowCount}  Rows successfully Removed`}
              </div>
            )}

            {closeClaimsModal && (
              <div className="epin-modal">
                <input
                  type={showPassword ? "text" : "password"}
                  style={{ border: "1px solid", height: "30px" }}
                  value={epin}
                  onChange={handleEpinChange}
                  placeholder="Enter your EPIN"
                />
                <FontAwesomeIcon
                  className="fa"
                  icon={showPassword ? faEye : faEyeSlash}
                  aria-hidden="true"
                  onClick={handleTogglePassword}
                  style={{ cursor: "pointer" }}
                />

                <br />
                <button
                  className=" border-white btn-style2 mt-1"
                  onClick={handleCloseModals}
                >
                  cancel
                </button>
                <button
                  className=" border-white btn-style2 mt-1"
                  style={{ marginLeft: "8px" }}
                  onClick={handleClosedClaims}
                >
                  confirm
                </button>
              </div>
            )}

            {isEPINVerifiedModal &&
              closeClaimChecbox.length > 0 &&
              verifiedEpin == 1 && (
                <div className="alert-modal">
                  <FontAwesomeIcon
                    className="closed-icon"
                    onClick={handleCloseModals}
                    icon={faXmark}
                  />
                  <p style={{ color: "white", marginTop: "30px" }}>
                    Claim closed successfully!
                  </p>
                </div>
              )}

            {isEPINVerifiedModal && verifiedEpin === 0 && (
              <div className="alert-modal">
                <FontAwesomeIcon
                  className="closed-icon"
                  onClick={handleCloseModals}
                  icon={faXmark}
                />
                <p style={{ color: "white", marginTop: "30px" }}>
                  Invalid EPIN
                </p>
              </div>
            )}


            {/* Fax Dialog UI */}

            {showFaxModal && (
              <Draggable>
                <div className="dialog-box">
                  <div>
                    <label value={selectedPatientID}>
                      Patient Name: {`${searchPatientText} `}{" "}
                    </label>

                    <FontAwesomeIcon
                      style={{
                        float: "right",
                        fontWeight: "bolder",
                        fontSize: "1.3rem",
                      }}
                      onClick={handleCloseModals}
                      icon={faXmark}
                    />
                  </div>

                  <table
                    className="table table-hover table-striped table-bordered border-secondary border-white responsive mt-1 mb-5"
                    style={{ marginLeft: "4px", width: "1200px" }}
                  >
                    <thead>
                      <tr className="align-top" style={{ fontSize: "0.5rem" }}>
                        <th
                          className='col-sm col-th text-white"'
                          style={{ backgroundColor: "#0173b7", width: "30px" }}
                        >
                          #
                        </th>

                        <th
                          className="col col-th-style  text-white"
                          style={{ backgroundColor: "#0173b7" }}
                        >
                          DOS
                        </th>

                        <th
                          className="col-sm col-th text-white"
                          style={{ backgroundColor: "#0173b7" }}
                        >
                          Provider
                        </th>
                        <th
                          className="col col-th-style  text-white"
                          style={{ backgroundColor: "#0173b7" }}
                        >
                          CPT
                        </th>
                        <th
                          className="col-sm col-th  text-white"
                          style={{ backgroundColor: "#0173b7" }}
                        >
                          Mod1
                        </th>
                        <th
                          className="col col-th-style  text-white"
                          style={{ backgroundColor: "#0173b7" }}
                        >
                          Mod2
                        </th>
                        <th
                          className="col col-th-style  text-white"
                          style={{ backgroundColor: "#0173b7" }}
                        >
                          Mod3
                        </th>
                        <th
                          className="col col-th-style  text-white"
                          style={{ backgroundColor: "#0173b7" }}
                        >
                          Diag1
                        </th>
                        <th
                          className="col col-th-style  text-white"
                          style={{ backgroundColor: "#0173b7" }}
                        >
                          Diag2
                        </th>
                        <th
                          className="col col-th-style  text-white"
                          style={{ backgroundColor: "#0173b7" }}
                        >
                          Diag3
                        </th>
                        <th
                          className="col col-th-style  text-white"
                          style={{ backgroundColor: "#0173b7" }}
                        >
                          Diag4
                        </th>
                        <th
                          className="col col-th-style  text-white"
                          style={{ backgroundColor: "#0173b7" }}
                        >
                          Unit
                        </th>
                        <th
                          className="col col-th-style  text-white"
                          style={{ backgroundColor: "#0173b7", width: "150px" }}
                        >
                          Unit Charge
                        </th>

                        <th></th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr className="align-top">
                        <td></td>

                        <td>
                          <DatePicker
                            selected={fromDate}
                            onChange={handleFromDateChange}
                            dateFormat="MM/dd/yyyy"
                            maxDate={new Date()}
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            yearDropdownItemNumber={100}
                            readOnly={isHideChecked}
                            className={`clnImgTextBoxes ${fromDate ? "default-selected" : ""}`}
                            placeholderText="MM/dd/yyyy"
                            renderCustomHeader={({
                              date,
                              changeYear,
                              changeMonth,
                              decreaseMonth,
                              increaseMonth,
                              prevMonthButtonDisabled,
                              nextMonthButtonDisabled,
                            }) => {
                              const selectedDate =
                                date instanceof Date && !isNaN(date)
                                  ? date
                                  : new Date();
                              const selectedMonth = selectedDate.getMonth();
                              const selectedYear = selectedDate.getFullYear();

                              return (
                                <div>
                                  <button
                                    onClick={decreaseMonth}
                                    disabled={prevMonthButtonDisabled}
                                    style={{ height: "25px" }}
                                  >
                                    {"<"}
                                  </button>
                                  <select
                                    value={selectedMonth}
                                    onChange={({ target: { value } }) =>
                                      changeMonth(Number(value))
                                    }
                                  >
                                    {getMonths(selectedYear)}
                                  </select>
                                  <select
                                    value={selectedYear}
                                    onChange={({ target: { value } }) =>
                                      changeYear(Number(value))
                                    }
                                  >
                                    {Array.from({ length: 100 }, (v, k) => (
                                      <option
                                        key={k}
                                        value={new Date().getFullYear() - k}
                                      >
                                        {new Date().getFullYear() - k}
                                      </option>
                                    ))}
                                  </select>
                                  <button
                                    onClick={increaseMonth}
                                    disabled={nextMonthButtonDisabled}
                                  >
                                    {">"}
                                  </button>
                                </div>
                              );
                            }}
                          />
                        </td>

                        <td>
                          <FontAwesomeIcon
                            className="search-icon2"
                            style={{ marginLeft: "110px" }}
                            icon={faMagnifyingGlass}
                          />
                          <input
                            type="text"
                            className="search-box-style"
                            style={{ width: "130px" }}
                            placeholder="Provider"
                            value={selectedProviderText}
                            onChange={(e) =>
                              setSelectedProviderText(e.target.value)
                            }
                            onKeyDown={handleProviderListKeyDown}
                          />

                          <div style={{ position: "sticky" }}>
                            <ul
                              className="list-style"
                              style={{ width: "130px", color: "black" }}
                            >
                              {Array.isArray(providerDataList) &&
                                providerDataList.map((suggestion) => (
                                  <li
                                    key={suggestion.id}
                                    onClick={() =>
                                      handleProviderSuggestionList(suggestion)
                                    }
                                  >
                                    {suggestion.label}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </td>
                        <td>
                          <FontAwesomeIcon
                            className="search-icon2"
                            style={{ marginLeft: "80px" }}
                            icon={faMagnifyingGlass}
                          />
                          <input
                            type="text"
                            className="search-box-style"
                            style={{ width: "100px" }}
                            placeholder="Procedure"
                            value={selectedCPTList}
                            onChange={(e) => setSelectedCPTList(e.target.value)}
                            onKeyUp={handleCPTListKeyDown}
                          />

                          <div style={{ position: "sticky" }}>
                            <ul
                              className="list-style"
                              style={{
                                width: "180px",
                                color: "black",
                                fontSize: "0.8rem",
                              }}
                            >
                              {Array.isArray(cptDataList) &&
                                cptDataList.map((suggestion) => (
                                  <li
                                    key={suggestion.val}
                                    onClick={() =>
                                      handleSearchCPTList(suggestion)
                                    }
                                  >
                                    {suggestion.CPT_Code}-
                                    {suggestion.CPTDescription}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </td>
                        <td>
                          <FontAwesomeIcon
                            className="search-icon2"
                            icon={faMagnifyingGlass}
                          />
                          <input
                            type="text"
                            className="search-box-style"
                            style={{ width: "65px" }}
                            placeholder="Mod1"
                            value={selectedModList ? selectedModList.val : ""}
                            onChange={(e) => setSelectedModList(e.target.value)}
                            onKeyUp={handleModListKeyDown}
                          />
                          <div style={{ position: "sticky" }}>
                            <ul
                              className="list-style"
                              style={{
                                width: "100px",
                                color: "black",
                                fontSize: "0.8rem",
                              }}
                            >
                              {Array.isArray(modDataList) &&
                                modDataList.map((suggestion) => (
                                  <li onClick={() => handleModList(suggestion)}>
                                    {suggestion.val != null ? (
                                      suggestion.val
                                    ) : (
                                      // Handle the case where 'val' is null or undefined
                                      <span style={{ color: "red" }}>
                                        Invalid Value
                                      </span>
                                    )}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </td>

                        <td>
                          <FontAwesomeIcon
                            className="search-icon2"
                            icon={faMagnifyingGlass}
                          />
                          <input
                            type="text"
                            className="search-box-style"
                            style={{ width: "65px" }}
                            placeholder="Mod2"
                            value={
                              selectedMod2Value ? selectedMod2Value.val : ""
                            }
                            onChange={(e) =>
                              setSelectedMod2Value(e.target.value)
                            }
                            onKeyUp={handleMod2ListKeyDown}
                          />

                          <div style={{ position: "sticky" }}>
                            <ul
                              className="list-style"
                              style={{
                                width: "65px",
                                color: "black",
                                fontSize: "0.8rem",
                              }}
                            >
                              {Array.isArray(mod2DataList) &&
                                mod2DataList.map((suggestion) => (
                                  <li
                                    onClick={() => handleMod2List(suggestion)}
                                  >
                                    {suggestion.val != null ? (
                                      suggestion.val
                                    ) : (
                                      // Handle the case where 'val' is null or undefined
                                      <span style={{ color: "red" }}></span>
                                    )}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </td>

                        <td>
                          <FontAwesomeIcon
                            className="search-icon2"
                            icon={faMagnifyingGlass}
                          />
                          <input
                            type="text"
                            className="search-box-style"
                            style={{ width: "65px" }}
                            placeholder="Mod3"
                            value={
                              selectedMod3Value ? selectedMod3Value.val : ""
                            }
                            onChange={(e) =>
                              setSelectedMod3Value(e.target.value)
                            }
                            onKeyUp={handleMod3ListKeyDown}
                          />

                          <div style={{ position: "sticky" }}>
                            <ul
                              className="list-style"
                              style={{
                                width: "65px",
                                color: "black",
                                fontSize: "0.8rem",
                              }}
                            >
                              {Array.isArray(mod3DataList) &&
                                mod3DataList.map((suggestion) => (
                                  <li
                                    onClick={() => handleMod3List(suggestion)}
                                  >
                                    {suggestion.val != null ? (
                                      suggestion.val
                                    ) : (
                                      // Handle the case where 'val' is null or undefined
                                      <span style={{ color: "red" }}>
                                        Invalid Value
                                      </span>
                                    )}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </td>
                        <td>
                          <FontAwesomeIcon
                            className="search-icon2"
                            icon={faMagnifyingGlass}
                          />
                          <input
                            type="text"
                            className="search-box-style"
                            style={{ width: "65px" }}
                            placeholder="Diag1"
                            value={selectedDiag1Value}
                            onChange={(e) =>
                              setSelectedDiag1Value(e.target.value)
                            }
                            onKeyUp={handleDiag1ListKeyDown}
                          />

                          <div style={{ position: "sticky" }}>
                            <ul
                              className="list-style"
                              style={{
                                width: "auto",
                                color: "black",
                                fontSize: "0.8rem",
                              }}
                            >
                              {Array.isArray(diag1DataList) &&
                                diag1DataList.map((suggestion) => (
                                  <li
                                    onClick={() => handleDiag1List(suggestion)}
                                  >
                                    {suggestion.Value}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </td>
                        <td>
                          <FontAwesomeIcon
                            className="search-icon2"
                            icon={faMagnifyingGlass}
                          />
                          <input
                            type="text"
                            className="search-box-style"
                            style={{ width: "65px" }}
                            placeholder="Diag2"
                            value={selectedDiag2Value}
                            onChange={(e) =>
                              setSelectedDiag2Value(e.target.value)
                            }
                            onKeyUp={handleDiag2ListKeyDown}
                          />

                          <div style={{ position: "sticky" }}>
                            <ul
                              className="list-style"
                              style={{
                                width: "auto",
                                color: "black",
                                fontSize: "0.8rem",
                              }}
                            >
                              {Array.isArray(diag2DataList) &&
                                diag2DataList.map((suggestion) => (
                                  <li
                                    onClick={() => handleDiag2List(suggestion)}
                                  >
                                    {suggestion.Value}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </td>
                        <td>
                          <FontAwesomeIcon
                            className="search-icon2"
                            icon={faMagnifyingGlass}
                          />
                          <input
                            type="text"
                            className="search-box-style"
                            style={{ width: "65px" }}
                            placeholder="Diag3"
                            value={selectedDiag3Value}
                            onChange={(e) =>
                              setSelectedDiag3Value(e.target.value)
                            }
                            onKeyUp={handleDiag3ListKeyDown}
                          />

                          <div style={{ position: "sticky" }}>
                            <ul
                              className="list-style"
                              style={{
                                width: "auto",
                                color: "black",
                                fontSize: "0.8rem",
                              }}
                            >
                              {Array.isArray(diag3DataList) &&
                                diag3DataList.map((suggestion) => (
                                  <li
                                    onClick={() => handleDiag3List(suggestion)}
                                  >
                                    {suggestion.Value}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </td>
                        <td>
                          <FontAwesomeIcon
                            className="search-icon2"
                            icon={faMagnifyingGlass}
                          />
                          <input
                            type="text"
                            className="search-box-style"
                            style={{ width: "65px" }}
                            placeholder="Diag4"
                            value={selectedDiag4Value}
                            onChange={(e) =>
                              setSelectedDiag4Value(e.target.value)
                            }
                            onKeyUp={handleDiag4ListKeyDown}
                          />

                          <div style={{ position: "sticky" }}>
                            <ul
                              className="list-style"
                              style={{
                                width: "auto",
                                color: "black",
                                fontSize: "0.8rem",
                              }}
                            >
                              {Array.isArray(diag4DataList) &&
                                diag4DataList.map((suggestion) => (
                                  <li
                                    onClick={() => handleDiag4List(suggestion)}
                                  >
                                    {suggestion.Value}
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </td>
                        <td>
                          <input
                            className="text-boxes"
                            style={{ width: "70px" }}
                            type="text"
                            value={selectedUnitValue}
                            onChange={(e) =>
                              setSelectedUnitValue(e.target.value)
                            }
                          />
                        </td>
                        <td>
                          <input
                            className="textboxes"
                            style={{ width: "70px" }}
                            type="text"
                            value={selectedUnitChargeValue}
                            onChange={(e) =>
                              setSelectedUnitChargeValue(e.target.value)
                            }
                          />
                        </td>

                        <td>
                          <FontAwesomeIcon
                            icon={faPlus}
                            onClick={handleAddRow}
                          />
                        </td>
                      </tr>

                      {rows.map((row, index) => (
                        <tr key={index}>
                          <td style={{ width: "30px" }}></td>
                          <td>{row.DOS}</td>
                          <td>{row.ProvderName}</td>
                          <td>{row.CPT}</td>
                          <td>{row.Mod1}</td>
                          <td>{row.Mod2}</td>
                          <td>{row.Mod3}</td>
                          <td>{row.ICDCode}</td>
                          <td>{row.ICDCode2}</td>
                          <td>{row.ICDCode3}</td>
                          <td>{row.ICDCode4}</td>
                          <td>{row.Unit}</td>
                          <td>{row.Unitcharge}</td>
                          <td>
                            <FontAwesomeIcon
                              style={{
                                fontSize: "1.5rem",
                                fontWeight: "bolder",
                              }}
                              icon={faMinus}
                              onClick={() => handleRemoveRow(index)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {showFaxError && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "0.9rem",
                        marginLeft: "570px",
                      }}
                    >
                      Please Add CPT
                    </p>
                  )}

                  {saveFaxError && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "0.9rem",
                        marginLeft: "570px",
                      }}
                    >
                      Please Add atleast One CPT
                    </p>
                  )}

                  {showFaxSaveMsg && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "0.9rem",
                        marginLeft: "570px",
                      }}
                    >
                      Are You sure to Save?
                    </p>
                  )}

                  {/* {showFaxConfirmMsg && (
          <p style={{color:'red', fontSize:'0.9rem', marginLeft:'570px'}}>Saving.....</p>
        )}
         */}

                  <button
                    className="diagbtn-style"
                    style={{ marginLeft: "600px" }}
                    onClick={handleSavedRows}
                  >
                    Save
                  </button>
                </div>
              </Draggable>
            )}
          </div>
        </div>
        <PrintColumnModal
          isOpen={showPrintPopup}
          onClose={() => setShowPrintPopup(false)}
          columns={columns}
          columnVisibility={printColumnVisibility}
          toggleColumn={togglePrintColumn}
          handleSelectAll={handleSelectAll}
          handleDeselectAll={handleDeselectAll}
          allSelected={allSelected}
          noneSelected={noneSelected}
          onPrint={handlePrint}
        />
        {/* {showPrintPopup && (
          <div className="column-popup">
            <h4>Select Columns to Print</h4>

            {columns.map((col) => (
              <label key={col.key} style={{ display: "block", fontSize: "16px" }}>
                <input
                  type="checkbox"
                  checked={printColumns.includes(col.key)}
                  onChange={() => togglePrintColumn(col.key)}
                />{" "}
                {col.label}
              </label>
            ))}

            <div style={{ marginTop: "15px" }}>
              <button className="btn-style" onClick={handlePrint}>
                Print
              </button>

              <button
                className="btn-style3"
                style={{ marginLeft: "10px" }}
                onClick={() => setShowPrintPopup(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        )} */}


        
            <div
              className="btn-container hide-on-print"
              style={{ marginLeft: "2400px" }}
            >
              <button className="btn-style" onClick={handleOpenApprovalModal}>
                Save for Approval
              </button>

              <button className="btn-style3" onClick={handleOpenDeleteModal}>
                Delete
              </button>
            </div>
      </div>
    </>
  );
};

export default IntelliBill;
